
import React, { useState, useEffect } from 'react';
import Conexao from '../../Config/conexao';
import axios from 'axios';
import emailjs from '@emailjs/browser';
import './InvestNC.css';
import moment from 'moment';
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import { Link } from 'react-router-dom';

import { Container, ContainerForm, TextFieldStyled } from "./styles";
import download from "downloadjs";
import { green } from '@mui/material/colors';
import Button from 'react-bootstrap/Button';
import { Navbar, Row, Col, Offcanvas } from 'react-bootstrap';



function InvestNC() {

  const [value, setValue] = useState("S");
  const [sucesso, setSucesso] = useState("S")

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [bloqueado, setBloqueado ] = useState(true);
  // = isDataLoaded !== true;

  const [showInput, setShowInput] = useState(false);
  const [pegaProtocolo, setPegaProtocolo] = useState();

  const [origem, setOrigem] = useState();
  const [cliente, setCliente] = useState();
  const [setorIdentificou, setSetorIdentificou] = useState();
  const [setorOrigem, setSetorOrigem] = useState();
  const [descrever, setDescrever] = useState();
  const [documentoDoCliente, setDocumentoDoCliente] = useState();
  const [responsavel1, setResponsavel1] = useState();
  const [responsavel2, setResponsavel2] = useState();
  const [reincidente, setReincidente] = useState();
  const [descricaoproblema, setDescricaoproblema] = useState();
  const [evidencia1, setEvidencia1] = useState();
  const [evidencia2, setEvidencia2] = useState();
  //constantes da parte2
  const [protocolo, setProtocolo] = useState();

  const [descAcaoCorretiva, setDescAcaoCorretiva] = useState();
  const [definidaPor, setDefinidaPor] = useState();
  const [executadaPor, setExecutadaPor] = useState();
  const [dataDefinidaPor, setDataDefinidaPor] = useState();
  const [dataExecutadaPor, setDataExecutadaPor] = useState();
  const [participante1, setParticipante1] = useState();
  const [participante2, setParticipante2] = useState();
  const [participante3, setParticipante3] = useState();
  const [participante4, setParticipante4] = useState();
  const [participante5, setParticipante5] = useState();
  const [setor1, setSetor1] = useState();
  const [setor2, setSetor2] = useState();
  const [setor3, setSetor3] = useState();
  const [setor4, setSetor4] = useState();
  const [setor5, setSetor5] = useState();
  const [porque1, setPorque1] = useState();
  const [porque2, setPorque2] = useState();
  const [porque3, setPorque3] = useState();
  const [porque4, setPorque4] = useState();
  const [porque5, setPorque5] = useState();
  const [descCausaIdentificada, setDescCausaIdentificada] = useState();
  const [analiseDeRisco, setAnaliseDeRisco] = useState();
  const [descAnaliseDeRisco, setDescAnaliseDeRisco] = useState();
  const [acaoCorretiva, setAcaoCorretiva] = useState();
  const [justAcaoCorretiva, setJustAcaoCorretiva] = useState();
  const [aplicAvelSetores, setAplicAvelSetores] = useState();
  const [descAplicavelSetores, setDescAplicavelSetores] = useState();
  const [item1, setItem1] = useState([]);
  const [item2, setItem2] = useState([]);
  const [item3, setItem3] = useState([]);
  const [acao1, setAcao1] = useState([]);
  const [acao2, setAcao2] = useState([]);
  const [acao3, setAcao3] = useState([]);
  const [responsavelAcao1, setResponsavelAcao1] = useState([]);
  const [responsavelAcao2, setResponsavelAcao2] = useState();
  const [responsavelAcao3, setResponsavelAcao3] = useState();
  const [previsaoAcao1, setPrevisaoAcao1] = useState([]);
  const [previsaoAcao2, setPrevisaoAcao2] = useState();
  const [previsaoAcao3, setPrevisaoAcao3] = useState();
  const [execucaoAcao1, setExecucaoAcao1] = useState([]);
  const [execucaoAcao2, setExecucaoAcao2] = useState();
  const [execucaoAcao3, setExecucaoAcao3] = useState();
  const [verAcao1, setVerAcao1] = useState();
  const [verAcao2, setVerAcao2] = useState();
  const [verAcao3, setVerAcao3] = useState();
  const [verResponsavelAcao1, setVerResponsavelAcao1] = useState();
  const [verResponsavelAcao2, setVerResponsavelAcao2] = useState();
  const [verResponsavelAcao3, setVerResponsavelAcao3] = useState();
  const [verPrevisaoAcao1, setVerPrevisaoAcao1] = useState();
  const [verPrevisaoAcao2, setVerPrevisaoAcao2] = useState();
  const [verPrevisaoAcao3, setVerPrevisaoAcao3] = useState();
  const [verExecucaoAcao1, setVerExecucaoAcao1] = useState();
  const [verExecucaoAcao2, setVerExecucaoAcao2] = useState();
  const [verExecucaoAcao3, setVerExecucaoAcao3] = useState();
  const [verResultado1, setVerResultado1] = useState();
  const [verResultado2, setVerResultado2] = useState();
  const [verResultado3, setVerResultado3] = useState();
  const [verComentario1, setVerComentario1] = useState();
  const [verComentario2, setVerComentario2] = useState();
  const [verComentario3, setVerComentario3] = useState();
  const [encerraResponsavel, setEncerraResponsavel] = useState();
  const [encerraData, setEncerraData] = useState();
  const [setorLogado, setSetorLogado] = useState();
  const [setorDoCargo, setSetorDoCargo] = useState();
  const [origemSetor, setOrigemSetor] = useState();

  const [acoes, setAcoes] = useState([]);
  const [verificaEficacia, setVerificaEficacia] = useState([]);

  const [listaVerificaEficacia, setListaVerificaEficacia] = useState([]);

  const [imagem, setImagem] = useState();
  const [imagemPreview, setImagemPreview] = useState();
  const [imagem2, setImagem2] = useState();
  const [imagemPreview2, setImagemPreview2] = useState();
  const [imagem3, setImagem3] = useState();
  const [imagemPreview3, setImagemPreview3] = useState();
  const [imagem4, setImagem4] = useState();
  const [imagemPreview4, setImagemPreview4] = useState();
  const [imagem5, setImagem5] = useState();
  const [imagemPreview5, setImagemPreview5] = useState();

  const [numeroItem, setNumeroItem] = useState(1);

  const [checkMaquina, setCheckMaquina] = useState();
  const [checkMeioAmbiente, setCheckMeioAmbiente] = useState();
  const [checkMetodo, setCheckMetodo] = useState();
  const [checkMateriaPrima, setCheckMateriaPrima] = useState();
  const [checkMedicao, setCheckMedicao] = useState();
  const [checkMaoDeObra, setCheckMaodeObra] = useState();
  const [showSidebar, setShowSidebar] = useState(false);
  const [liClicked, setLiClicked] = useState(false);
  const [efeito, setEfeito] = useState();

  const [maquina, setMaquina] = useState();
  const [meioAmbiente, setMeioAmbiente] = useState();
  const [metodo, setMetodo] = useState();
  const [materiaPrima, setMateriaPrima] = useState();
  const [medicao, setMedicao] = useState();
  const [maoDeObra, setMaoDeObra] = useState();

  const [dataAtual, setDataAtual] = useState();

  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    //setBackgroundImage(images[index]);

}
const handleCloseSidebar = () => {
  setShowSidebar(false);

}


  const listaDeAcoes = acoes.map((f, i) => <div key={i} class="row d-flex align-items-start justify-content-center ">
    <div class="col-1">{f.item1} </div>
    {/*  <div class="col-4 ">{f.acao1}</div> */}
    <div class="col-4"> <textarea rows={3} cols={50} readOnly className=" bordaa  text-center colorInput resize">{f.acao1}</textarea></div>
    <div class="col-2">{f.responsavelAcao1}</div>
    <div class="col-2">{f.acao1 && (moment(f.previsaoAcao1).format('DD/MM/YYYY'))} </div>
    <div class="col-1">{f.acao1 && (moment(f.execucaoAcao1).format('DD/MM/YYYY'))}</div>
    {f.acao1 && (<div class="col-2">  <button onClick={() => ClickDelete(f.id)} className="far fa-trash-alt icone-acao red botaao"></button></div>)}
  </div>)


  const [atrasox, setAtrasoX] = useState();


  //lista ações  ****************************************************************************************************
  async function SalvarAcoes() {
    const novoItem = numeroItem;
    // const atrasox = "NÃO";

    // setAtrasoX('NÃO')

    setAtrasoX("NÃO");

    const obj = { protocolo, item1: novoItem, acao1, responsavelAcao1, previsaoAcao1, execucaoAcao1, atrasox };
    const res = await axios.post(Conexao.api + 'InsertAcoesRNCWEB.php', obj);
    console.log(res)
    if (res.data.success === true) {
    

    console.log("salvoooooou")
    alert("Foi Salvo")
    }
    else{
      console.log("não salvou :(")
      alert("não foi possível salvar")
    }
  };


  async function BuscarAcoes() {
    const res = await axios.get(Conexao.api + 'ListaRNCAcoesWEB.php?protocolo=' + protocolo);
    console.log(res.data.result)
    if (res.data.success === false) {

    } else {

      setAcoes(res.data.result)

    }
  };

  function Limpar() {

    setOrigemSetor('');
    setOrigem('');
    setCliente('');
    setSetorIdentificou('');
    setSetorOrigem('');
    setDescrever('');
    setDocumentoDoCliente('');
    setResponsavel1('');
    setResponsavel2('');
    setReincidente('');
    setDescricaoproblema('');
    setEvidencia1('');
    setEvidencia2('');

    setDescAcaoCorretiva('');
    setDefinidaPor('');
    setExecutadaPor('');
    setDataDefinidaPor('');
    setDataExecutadaPor('');
    setParticipante1('');
    setParticipante2('');
    setParticipante3('');
    setParticipante4('');
    setParticipante5('');
    setSetor1('');
    setSetor2('');
    setSetor3('');
    setSetor4('');
    setSetor5('');
    setPorque1('');
    setPorque2('');
    setPorque3('');
    setPorque4('');
    setPorque5('');
    setDescCausaIdentificada('');
    setAnaliseDeRisco('');
    setDescAnaliseDeRisco('');
    setAcaoCorretiva('');
    setJustAcaoCorretiva('');
    setAplicAvelSetores('');
    setDescAplicavelSetores('');
    setItem1('');
    setItem2('');
    setItem3('');
    setAcao1('');
    setAcao2('');
    setAcao3('');
    setResponsavelAcao1('');
    setResponsavelAcao2('');
    setResponsavelAcao3('');
    setPrevisaoAcao1('');
    setPrevisaoAcao2('');
    setPrevisaoAcao3('');
    setExecucaoAcao1('');
    setExecucaoAcao2('');
    setExecucaoAcao3('');
    setVerAcao1('');
    setVerAcao2('');
    setVerAcao3('');
    setVerResponsavelAcao1('');
    setVerResponsavelAcao2('');
    setVerResponsavelAcao3('');
    setVerPrevisaoAcao1('');
    setVerPrevisaoAcao2('');
    setVerPrevisaoAcao3('');
    setVerExecucaoAcao1('');
    setVerExecucaoAcao2('');
    setVerExecucaoAcao3('');
    setVerResultado1('');
    setVerResultado2('');
    setVerResultado3('');
    setVerComentario1('');
    setVerComentario2('');
    setVerComentario3('');
    setEncerraResponsavel('');
    setEncerraData('');

    setAcoes(['']);
    setVerificaEficacia(['']);

    setImagem('');
    setImagemPreview('');
    setImagem2('');
    setImagemPreview2('');
    setImagem3('');
    setImagemPreview3('');
    setImagem4('');
    setImagemPreview4('');
    setImagem5('');
    setImagemPreview5('');

    setCheckMaquina('');
    setCheckMeioAmbiente('');
    setCheckMetodo('');
    setCheckMateriaPrima('');
    setCheckMedicao('');
    setCheckMaodeObra('');

    setEfeito('');

    setMaquina('');
    setMeioAmbiente('');
    setMetodo('');
    setMateriaPrima('');
    setMedicao('');
    setMaoDeObra('');
    setNomeResponsavel(['']);

    LimparAcao();
    LimparVerificacao();
    // Bloquear();

    setSetorOrigem('');

    setDataAtual('');




    // setNumeroItem(''); 

  };

  function LimparAcao() {
    setItem1('');
    setAcao1('');
    setResponsavelAcao1('');
    setPrevisaoAcao1('');
    setExecucaoAcao1('');
    //setNumeroItem(''); 
  };

  function LimparVerificacao() {
    setVerAcao1('');
    setVerResponsavelAcao1('');
    setVerPrevisaoAcao1('');
    setVerExecucaoAcao1('');
    setVerResultado1('');
    setVerComentario1('');
  };


  useEffect(() => {
    // Ao montar o componente ou após uma busca de dados, atualize o valor de numeroItem com base nos dados existentes
    if (acoes.length > 0) {
      const ultimoItem = acoes[acoes.length - 1].item1;
      const numero = extrairNumeroDoItem(ultimoItem);
      setNumeroItem(numero + 1);
    }
  }, [acoes]);

  const extrairNumeroDoItem = (item) => {
    const padrao = /^(\d+)$/; // Expressão regular para verificar o padrão "Item X"
    if (item && padrao.test(item)) {
      return parseInt(item.match(padrao)[1]);
    }
    return 0; // Retorna 1 caso o item não siga o padrão ou seja nulo/vazio
  };


  //const handleDelete = (id) => {
  function ClickDelete(id) {
    deleteUser(id)
    const updatedAcoes = acoes.filter((f) => f.id !== id);
    setAcoes(updatedAcoes);
  };

  async function deleteUser(id) {
    const res = await axios.get(Conexao.api + 'ExcluirAcoesRNCWEB.php?id=' + id);
    if (res.data.success === true) {
      // setConfirmacao(false);
      BuscarAcoes()
    }
  };


  const AcoesClick = async () => {
    // Salva os dados no banco de dados
    await SalvarAcoes();
    // Busca os dados atualizados
    await BuscarAcoes();
  };



  //lista ações  ****************************************************************************************************
  async function SalvarVerificaEficacia() {
    const obj = { protocolo, verAcao1, verResponsavelAcao1, verPrevisaoAcao1, verResultado1, verExecucaoAcao1, verComentario1, };
    const res = await axios.post(Conexao.api + 'InsertVerificaEficaciaWEB.php', obj);
    console.log(res)
    if (res.data.success === true) {

    }
    // Confirmacao()
    console.log("salvoooooou")
  };



  async function BuscarVerificaEficacia() {
    const res = await axios.get(Conexao.api + 'ListaVerificaEficaciaWEB.php?protocolo=' + protocolo);
    console.log(res.data.result)
    //setPegaIdVerificacao(res.data.result[0].id)
    if (res.data.success === false) {

    } else {

      setVerificaEficacia(res.data.result);
      setListaVerificaEficacia(res.data.result);
    }
  };


  function ClickDeleteVerifica(id) {
    console.log('ID a ser excluído:', id);
    deleteUserVerifica(id);
    const updatedVerificaEficacia = verificaEficacia.filter((v) => v.id !== id);
    setVerificaEficacia(updatedVerificaEficacia);
    console.log("o que é, o que é? " + updatedVerificaEficacia);
  };

  async function deleteUserVerifica(id) {
    const res = await axios.get(Conexao.api + 'ExcluirVerificaEficaciaWEB.php?id=' + id);
    console.log('Este é o id apagado:', id);
    if (res.data.success === true) {
      // setConfirmacao(false);
      BuscarVerificaEficacia();
    } else {
      console.log('Erro ao excluir item:', res.data.message);
    }
  };



  const VerificaEficaciaClick = async () => {
    if(descAcaoCorretiva !== '0' && descAcaoCorretiva !==''){
    // Salva os dados no banco de dados
    await SalvarVerificaEficacia();
    // Busca os dados atualizados
    await BuscarVerificaEficacia();
    }
    else{

      alert("preencha o campo da causa raiz")
    }
  };
  

  function NaoEncontrado() {
    alert('RNC não encontrado!')
  }

  //BUSCAR

  async function getItem() {
    const res = await axios.get(Conexao.api + 'BuscarRNCWEB.php? protocolo=' + protocolo);
    // setPegaProtocolo(res.data.pegaProtocolo);

    console.log("AAAABBBB  " + res.data.responsavel1);


    console.log("AAAA  " + res.data.verResultado3);

    if (res.data.success === false) { NaoEncontrado(); }

    else {
      setOrigemSetor(res.data.origemSetor);
      setOrigem(res.data.origem);
      setCliente(res.data.cliente);
      setSetorIdentificou(res.data.setorIdentificou);
      setSetorOrigem(res.data.setorOrigem);
      setDescrever(res.data.descrever);
      setDocumentoDoCliente(res.data.documentoDoCliente);
      setResponsavel1(res.data.responsavel1);
      setResponsavel2(res.data.responsavel2);
      setReincidente(res.data.reincidente);
      setDescricaoproblema(res.data.descricaoproblema);
      setEvidencia1(res.data.evidencia1);
      setEvidencia2(res.data.evidencia2);


      setDescAcaoCorretiva(res.data.descAcaoCorretiva);
      setDefinidaPor(res.data.definidaPor);
      setExecutadaPor(res.data.executadaPor);
      setDataDefinidaPor(res.data.dataDefinidaPor);
      setDataExecutadaPor(res.data.dataExecutadaPor);
      setParticipante1(res.data.participante1);
      setParticipante2(res.data.participante2);
      setParticipante3(res.data.participante3);
      setParticipante4(res.data.participante4);
      setParticipante5(res.data.participante5);
      setSetor1(res.data.setor1);
      setSetor2(res.data.setor2)
      setSetor3(res.data.setor3);
      setSetor4(res.data.setor4);
      setSetor5(res.data.setor5);
      setPorque1(res.data.porque1);
      setPorque2(res.data.porque2);
      setPorque3(res.data.porque3);
      setPorque4(res.data.porque4);
      setPorque5(res.data.porque5);
      setDescCausaIdentificada(res.data.descCausaIdentificada);
      setAnaliseDeRisco(res.data.analiseDeRisco);
      setDescAnaliseDeRisco(res.data.descAnaliseDeRisco);
      setAcaoCorretiva(res.data.acaoCorretiva);
      setJustAcaoCorretiva(res.data.justAcaoCorretiva);
      setAplicAvelSetores(res.data.aplicAvelSetores);
      setDescAplicavelSetores(res.data.descAplicavelSetores);

      /* setItem1(res.data.item1);
        setItem2(res.data.item2);
       setItem3(res.data.item3); 
       setAcao1(res.data.acao1);
        setAcao2(res.data.acao2);
       setAcao3(res.data.acao3); 
       setResponsavelAcao1(res.data.responsavelAcao1);
        setResponsavelAcao2(res.data.responsavelAcao2);
       setResponsavelAcao3(res.data.responsavelAcao3); 
       setPrevisaoAcao1(res.data.previsaoAcao1);
        setPrevisaoAcao2(res.data.previsaoAcao2);
       setPrevisaoAcao3(res.data.previsaoAcao3); 
       setExecucaoAcao1(res.data.execucaoAcao1);
      setExecucaoAcao2(res.data.execucaoAcao2);
       setExecucaoAcao3(res.data.execucaoAcao3); 
       setVerAcao1(res.data.verAcao1);
       setVerAcao2(res.data.verAcao2);
       setVerAcao3(res.data.verAcao3);
       setVerResponsavelAcao1(res.data.verResponsavelAcao1);
       setVerResponsavelAcao2(res.data.verResponsavelAcao2);
       setVerResponsavelAcao3(res.data.verResponsavelAcao3);
       setVerPrevisaoAcao1(res.data.verPrevisaoAcao1);
       setVerPrevisaoAcao2(res.data.verPrevisaoAcao2);
       setVerPrevisaoAcao3(res.data.verPrevisaoAcao3);
       setVerExecucaoAcao1(res.data.verExecucaoAcao2);
       setVerExecucaoAcao2(res.data.verExecucaoAcao2);
       setVerExecucaoAcao3(res.data.verExecucaoAcao3);
       setVerResultado1(res.data.verResultado1);
       setVerResultado2(res.data.verResultado2);
       setVerResultado3(res.data.verResultado3);
       setVerComentario1(res.data.verComentario1);
       setVerComentario2(res.data.verComentario2);
       setVerComentario3(res.data.verComentario3); */
      setEncerraResponsavel(res.data.encerraResponsavel);
      setEncerraData(res.data.encerraData);

      setImagem(res.data.imagem);
      setImagemPreview(res.data.imagem);
      setImagem2(res.data.imagem2);
      setImagemPreview2(res.data.imagem2);
      setImagem3(res.data.imagem3);
      setImagemPreview3(res.data.imagem3);
      setImagem4(res.data.imagem4);
      setImagemPreview4(res.data.imagem4);
      setImagem5(res.data.imagem5);
      setImagemPreview5(res.data.imagem5);

      setCheckMaquina(res.data.checkMaquina);
      setCheckMeioAmbiente(res.data.checkMeioAmbiente);
      setCheckMetodo(res.data.checkMetodo);
      setCheckMateriaPrima(res.data.checkMateriaPrima);
      setCheckMedicao(res.data.checkMedicao);
      setCheckMaodeObra(res.data.checkMaoDeObra);

      setEfeito(res.data.efeito);

      setMaquina(res.data.maquina);
      setMeioAmbiente(res.data.meioAmbiente);
      setMetodo(res.data.metodo);
      setMateriaPrima(res.data.materiaPrima);
      setMedicao(res.data.medicao);
      setMaoDeObra(res.data.maoDeObra);

      setDataAtual(res.data.dataAtual);
      setSubStatu(res.data.substatu);



      if (res.data.substatu !== 'Encerrado') {
        setIsDataLoaded(true);

      };

      if (res.data.origem === 'Outros') {
        setShowInput(true);

      };

      if (res.data.origem !== 'Outros') {
        setShowInput(false);

      };

      // if (res.data.responsavel2 !== comparaNome && setorDoCargo !== 'SGI') { setBlock(true) }
      // else if (res.data.responsavel2 === comparaNome && setorDoCargo !== 'SGI') { setBlock(false) }
      // else if (res.data.responsavel2 !== comparaNome && setorDoCargo === 'SGI') { setBlock(false) }



      /* setIsDataLoaded(true); */
      BuscarVerificaEficacia();
      BuscarAcoes();

    };
  };

  /*        function NCEncerrado(){
          if(subStatu === 'Encerrado'){setIsDataLoaded (false);};
         }; */

  const [block, setBlock] = useState(false)


  const [subStatu, setSubStatu] = useState();


  function Bloquear() { setIsDataLoaded(false) };
 


  function LimparAcao() {
    setItem1('');
    setAcao1('');
    setResponsavelAcao1('');
    setPrevisaoAcao1('');
    setExecucaoAcao1('');
    //setNumeroItem(''); 
  };

  function LimparVerificacao() {
    setVerAcao1('');
    setVerResponsavelAcao1('');
    setVerPrevisaoAcao1('');
    setVerExecucaoAcao1('');
    setVerResultado1('');
    setVerComentario1('');
  };



  const [comparaNome, setComparaNome] = useState();

  function carregaUser() { setSetorLogado(localStorage.usuario) };
  useEffect(() => { carregaUser() }, []);

  async function getSetor() {
    const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
    if (res.data.success === false) {
      //  setLoading(false)
      //  falha();  
    } else {
      setSetorDoCargo(res.data.setor);
      setComparaNome(res.data.nome)
      // console.log( "SEETOOOOOR  " + setorDoCargo);
      console.log(res.data.setor);
      console.log("QUEEEEM  " + setorLogado);
    }
  };



  const isDisabled = setorDoCargo !== 'SGI' || setorDoCargo === 'SGI';
  const isDisabled2 = setorDoCargo !== 'SGI';








  const [nomeResponsavel, setNomeResponsavel] = useState([]);


  async function getResponsavel() {
    const res = await axios.get(Conexao.api + 'ListaCadastroDeResponsaveisWEB.php?responsavel2=' + setorOrigem);

    /* console.log("TESTE DE PROTOCOLO "+ res.data.pegaProtocolo) */
    if (res.data.success === false) {
    } else {
      // LimpaResponsavel(); 
      setNomeResponsavel(res.data.result);

    }
  };


  const [nomeResponsavel2, setNomeResponsavel2] = useState([]);


  async function getResponsavel2() {
    const res = await axios.get(Conexao.api + 'ListaCadastroDeResponsaveisWEB.php?responsavel2=' + setorIdentificou);

    /* console.log("TESTE DE PROTOCOLO "+ res.data.pegaProtocolo) */
    if (res.data.success === false) {
    } else {
      // LimpaResponsavel(); 
      setNomeResponsavel2(res.data.result);

    }
  };

  //  useEffect(()=>{getResponsavel()});


  //77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777


  const handleDescricaoChange = (e) => {
    setDescricaoproblema(e.target.value);
  };

  const handleImagemChange = (e) => {
    const file = e.target.files[0];
    setImagem(file);
    // Criando uma URL temporária para exibir a prévia da imagem selecionada
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagemPreview(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }

  };

  const handleDownloadClick = () => {
    // Verifica se a imagem está disponível para download
    if (imagemPreview) {
      const link = document.createElement('a');
      link.href = imagemPreview;
      link.download = "imagem_selecionada.jpg"; // O nome que você quer dar ao arquivo baixado
      link.click();
    } else {
      console.log("Nenhuma imagem selecionada para download.");
    }
  };

  //77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777


  const handleDescricaoChange2 = (e) => {
    setDescricaoproblema(e.target.value);
  };

  const handleImagemChange2 = (e) => {
    const file = e.target.files[0];
    setImagem2(file);
    // Criando uma URL temporária para exibir a prévia da imagem selecionada
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagemPreview2(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleDownloadClick2 = () => {
    // Verifica se a imagem está disponível para download
    if (imagemPreview2) {
      const link = document.createElement('a');
      link.href = imagemPreview2;
      link.download = "imagem_selecionada.jpg"; // O nome que você quer dar ao arquivo baixado
      link.click();
    } else {
      console.log("Nenhuma imagem selecionada para download.");
    }
  };
  //77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777


  /*   const handleDescricaoChange3 = (e) => {
      setDescricaoproblema(e.target.value);
    }; */

  const handleImagemChange3 = (e) => {
    const file = e.target.files[0];
    setImagem3(file);
    // Criando uma URL temporária para exibir a prévia da imagem selecionada
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagemPreview3(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleDownloadClick3 = () => {
    // Verifica se a imagem está disponível para download
    if (imagemPreview3) {
      const link = document.createElement('a');
      link.href = imagemPreview3;
      link.download = "imagem_selecionada.jpg"; // O nome que você quer dar ao arquivo baixado
      link.click();
    } else {
      console.log("Nenhuma imagem selecionada para download.");
    }
  };
  //77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777


  /*    const handleDescricaoChange4 = (e) => {
       setDescricaoproblema(e.target.value);
     }; */

  const handleImagemChange4 = (e) => {
    const file = e.target.files[0];
    setImagem4(file);
    // Criando uma URL temporária para exibir a prévia da imagem selecionada
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagemPreview4(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleDownloadClick4 = () => {
    // Verifica se a imagem está disponível para download
    if (imagemPreview4) {
      const link = document.createElement('a');
      link.href = imagemPreview4;
      link.download = "imagem_selecionada.jpg"; // O nome que você quer dar ao arquivo baixado
      link.click();
    } else {
      console.log("Nenhuma imagem selecionada para download.");
    }
  };
  //77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777


  /*         const handleDescricaoChange5 = (e) => {
            setDescricaoproblema(e.target.value);
          }; */

  const handleImagemChange5 = (e) => {
    const file = e.target.files[0];
    setImagem5(file);
    // Criando uma URL temporária para exibir a prévia da imagem selecionada
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagemPreview5(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleDownloadClick5 = () => {
    // Verifica se a imagem está disponível para download
    if (imagemPreview5) {
      const link = document.createElement('a');
      link.href = imagemPreview5;
      link.download = "imagem_selecionada.jpg"; // O nome que você quer dar ao arquivo baixado
      link.click();
    } else {
      console.log("Nenhuma imagem selecionada para download.");
    }
  };

  //555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555

  function LimpaResponsavel() { setResponsavel1('') && setResponsavel2(''); };

  useEffect(() => {
    getResponsavel();
  }, [setorOrigem]);

  useEffect(() => {
    getResponsavel2();
  }, [setorIdentificou]);



  const [popup1, setPopUp1] = useState(false);
  const [popup2, setPopUp2] = useState(false);
  const [popup3, setPopUp3] = useState(false);
  const [popup4, setPopUp4] = useState(false);
  const [popup5, setPopUp5] = useState(false);
  const [popup6, setPopUp6] = useState(false);

  function MudaPopUp1() {
    setPopUp1(!popup1);
  };
  function MudaPopUp2() {
    setPopUp2(!popup2);
  };
  function MudaPopUp3() {
    setPopUp3(!popup3);
  };
  function MudaPopUp4() {
    setPopUp4(!popup4);
  };
  function MudaPopUp5() {
    setPopUp5(!popup5);
  };
  function MudaPopUp6() {
    setPopUp6(!popup6);
  };



  /* ********************************************************************************************************************** */

  const [assinaturaEncerramento, setAssinaturaEncerramento] = useState();
  const [assinaturaExecucao, setAssinaturaExecucao] = useState();
  const [assinaturaAbertura, setAssinaturaAbertura] = useState();

  async function getAssinatura() {
    const res = await axios.get(Conexao.api + 'BuscarAssinaturaSSMTWEB.php? encerraResponsavel=' + encerraResponsavel);
    if (res.data.success === false) {
      setAssinaturaEncerramento('')
      // NaoEncontra();   
    } else {
      setAssinaturaEncerramento(res.data.assinaturaencImagem)
    }
  };

  async function getAssinatura2() {
    const res = await axios.get(Conexao.api + 'BuscarAssinaturaSSMTWEB2.php? responsavel1=' + responsavel1);
    if (res.data.success === false) {
      setAssinaturaAbertura('')
      // NaoEncontra();   
    } else {
      setAssinaturaAbertura(res.data.assinaturaencImagem2)
    }
  };

  async function getAssinatura3() {
    const res = await axios.get(Conexao.api + 'BuscarAssinaturaSSMTWEB3.php? executadaPor=' + executadaPor);
    if (res.data.success === false) {
      setAssinaturaExecucao('')
      // NaoEncontra();   
    } else {
      setAssinaturaExecucao(res.data.assinaturaencImagem3)
    }
  };

  useEffect(() => { getAssinatura() }, [encerraResponsavel]);
  useEffect(() => { getAssinatura2() }, [responsavel1]);
  useEffect(() => { getAssinatura3() }, [executadaPor]);




  const [listaLogin, setListaLogin] = useState([]);

  async function getLogin() {
    const res = await axios.get(Conexao.api + 'ListaLogin.php');
    if (res.data.success === false) {
    } else {
      setListaLogin(res.data.result);
    }
  };





  useEffect(() => {
    getLogin();
  }, []);




  function CarregarUsuario() {

    setVerResponsavelAcao1(localStorage.usuario);

  };

  useEffect(() => { CarregarUsuario() });



  //const[pageCountX, setpageCountX]=useState();

  async function GerarPDF() {

    const pdfDoc = await PDFDocument.create();

    const arialFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const arialBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);



    const textoDescricaoProblema = descricaoproblema || "";
    const textoEvidencias = evidencia1 || "";
    const maxCaracteresPorLinha = 120; // Defina o número máximo de caracteres por linha

    // setpageCountX(pdfDoc.getPages().length)


    //8888888888888888888888888888888888888888888888888888888888888888888888888888

    function quebrarTextoEmLinhas(texto, maxCaracteresPorLinha) {
      const palavras = texto.split(" ");
      let linhas = [];
      let linhaAtual = "";

      for (const palavra of palavras) {
        if (linhaAtual.length + (linhaAtual === "" ? 0 : 1) + palavra.length <= maxCaracteresPorLinha) {
          linhaAtual += (linhaAtual === "" ? "" : " ") + palavra;
        } else {
          linhas.push(linhaAtual);
          linhaAtual = palavra;
        }
      }

      if (linhaAtual !== "") {
        linhas.push(linhaAtual);
      }

      return linhas;
    }

    const pdfDoc2 = await PDFDocument.create();
    let currentPage = pdfDoc.addPage();
    let currentPageHeight = 645;

    const { width, height } = currentPage.getSize();


    let pageCount = 1;




    // CABEÇALHO

    // LOGO GEOCONTROLE



    const imageUrl = 'data:image/png;base64,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';
    const imageBytes = await fetch(imageUrl).then(response => response.arrayBuffer());

    // Inserir a imagem na posição desejada
    const image = await pdfDoc.embedPng(imageBytes);
    const imageDims = image.scale(0.2); // Ajuste o fator de escala conforme necessário

    const xPosition = 27; // Ajuste a posição X da imagem
    const yPosition = 795; // Ajuste a posição Y da imagem

    const linhasDescricaoProblema = quebrarTextoEmLinhas(textoDescricaoProblema, maxCaracteresPorLinha);
    const linhasEvidencias = quebrarTextoEmLinhas(textoEvidencias, maxCaracteresPorLinha);

    let retanguloY = currentPageHeight;
    const fontSize = 9;
    const lineHeight = 14; // Espaçamento entre as linhas
    const textColor = rgb(0, 0, 0);

    const linhasAcaoContencao = quebrarTextoEmLinhas(descAcaoCorretivaText, maxCaracteresPorLinha);
    const retanguloAltura3 = (linhasAcaoContencao.length + 1) * lineHeight;

    const textoAcaoContencao = "Descrição:";
    const descAcaoCorretivaText = descAcaoCorretiva || "";

    const retanguloAltura1 = (linhasDescricaoProblema.length + 1) * lineHeight;

    currentPage.drawImage(image || "", {
      x: xPosition,
      y: yPosition,
      width: imageDims.width,
      height: imageDims.height,
    });

    const imageUrl2 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArMAAABACAIAAACGHGjSAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAhdEVYdENyZWF0aW9uIFRpbWUAMjAyMzowODozMSAxMzoxMDo0Ob1mDjYAAAEtSURBVHhe7d3BCQJBEEXBXVMxHg3WjcdYWpCR50XwKlZd5ofw6MvsM7MBADyd1gsAoAwAgHfKAACIMgAAogwAgCgDACDKAACIMgAAogwAgCgDACDKAACIMgAA8tWPSufbZS0A4Gfdr8dan7kZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAkH1m1gQA/p6bAQAQZQAARBkAAFEGAECUAQAQZQAARBkAAFEGAECUAQAQZQAARBkAAFEGAECUAQAQZQAAvGzbA0nODHURHqEnAAAAAElFTkSuQmCC';
    const imageBytes2 = await fetch(imageUrl2).then(response => response.arrayBuffer());

    // Inserir a imagem na posição desejada
    const image2 = await pdfDoc.embedPng(imageBytes2);
    const imageDims2 = image2.scale(0.5); // Ajuste o fator de escala conforme necessário

    const xPosition2 = 369; // Ajuste a posição X da imagem
    const yPosition2 = 792; // Ajuste a posição Y da imagem

    currentPage.drawImage(image2 || "", {
      x: xPosition2,
      y: yPosition2,
      width: 200,
      height: 35,
    });

    if (retanguloY - (linhasAcaoContencao.length * lineHeight) - 221 < 70) {
      currentPage = pdfDoc.addPage(); // Adiciona uma nova página
      /*     currentPageHeight = currentPage.getHeight(); // Reinicializa a altura da nova página */

      pageCount++;
      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });



      retanguloY = 1035;

      const columnData = [
        { x: 30, width: 267, text: participante5 || "" },
        { x: 298, width: 267, text: setor5 || "" },
      ];

      for (const column of columnData) {

        const textX = column.x + (column.width / 2) - (column.text.length * 2.3);

        currentPage.drawText(column.text, {

          x: textX, // Ajuste para alinhar o texto dentro do retângulo
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 221, // Ajuste para alinhar o texto verticalmente no retângulo
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      };



    } else {
    const columnData = [
      { x: 30, width: 267, text: participante5 || "" },
      { x: 298, width: 267, text: setor5 || "" },
    ];

    for (const column of columnData) {

      const textX = column.x + (column.width / 2) - (column.text.length * 2.3);

      currentPage.drawText(column.text, {

        x: textX, // Ajuste para alinhar o texto dentro do retângulo
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 221, // Ajuste para alinhar o texto verticalmente no retângulo
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    };

  }
    if (retanguloY - (linhasAcaoContencao.length * lineHeight) - 250 < 70) {
      currentPage = pdfDoc.addPage(); // Adiciona uma nova página
      /*     currentPageHeight = currentPage.getHeight(); // Reinicializa a altura da nova página */
      retanguloY = 1035;

      pageCount++;

      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });


      currentPage.drawText('Diagrama de Ishikawa', {
        x: 255,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 250,
        size: 10, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

    } else {

      currentPage.drawText('Diagrama de Ishikawa', {
        x: 255,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 250,
        size: 10, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

    }



    if (retanguloY - (linhasAcaoContencao.length * lineHeight) - 275 < 70) {
      currentPage = pdfDoc.addPage(); // Adiciona uma nova página
      /*     currentPageHeight = currentPage.getHeight(); // Reinicializa a altura da nova página */
      retanguloY = 975;

      pageCount++;

      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });


      if (checkMateriaPrima) {
        currentPage.drawRectangle({
          x: 180,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 180,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Matéria-prima', {
        x: 190,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 274,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });



      if (checkMaquina) {
        currentPage.drawRectangle({
          x: 272,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 272,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Máquina', {
        x: 282,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 274,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });



      if (checkMaoDeObra) {
        currentPage.drawRectangle({
          x: 352,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 352,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Mão de obra', {
        x: 362,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 274,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });


    } else {

      if (checkMateriaPrima) {
        currentPage.drawRectangle({
          x: 180,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 180,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Matéria-prima', {
        x: 190,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 274,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });



      if (checkMaquina) {
        currentPage.drawRectangle({
          x: 272,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 272,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Máquina', {
        x: 282,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 274,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });



      if (checkMaoDeObra) {
        currentPage.drawRectangle({
          x: 352,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 352,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Mão de obra', {
        x: 362,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 274,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


    }



    if (retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 < 70) {
      currentPage = pdfDoc.addPage(); // Adiciona uma nova página
      /*     currentPageHeight = currentPage.getHeight(); // Reinicializa a altura da nova página */

      retanguloY = 975;

      pageCount++;
      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });



      currentPage.drawLine({
        start: { x: 170, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        end: { x: 420, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.75,
      })

      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

    } else {

      currentPage.drawLine({
        start: { x: 170, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        end: { x: 420, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.75,
      })

    }



    if (retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 < 70 || retanguloY - (linhasAcaoContencao.length * lineHeight) - 275 < 70 || retanguloY - (linhasAcaoContencao.length * lineHeight) - 315 < 70) {
      currentPage = pdfDoc.addPage(); // Adiciona uma nova página
      /*     currentPageHeight = currentPage.getHeight(); // Reinicializa a altura da nova página */
      retanguloY = 975;

      pageCount++;
      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });



      // diagonal 1
      currentPage.drawLine({
        start: { x: 188, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275 },
        end: { x: 200, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })

      // diagonal 2
      currentPage.drawLine({
        start: { x: 280, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275 },
        end: { x: 292, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })

      // diagonal 3
      currentPage.drawLine({
        start: { x: 360, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275 },
        end: { x: 372, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })


      // diagonal 4
      currentPage.drawLine({
        start: { x: 188, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 315 },
        end: { x: 200, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })

      // diagonal 5
      currentPage.drawLine({
        start: { x: 280, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 315 },
        end: { x: 292, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })

      // diagonal 6
      currentPage.drawLine({
        start: { x: 360, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 315 },
        end: { x: 372, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })

      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

    } else {

      // diagonal 1
      currentPage.drawLine({
        start: { x: 188, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275 },
        end: { x: 200, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })

      // diagonal 2
      currentPage.drawLine({
        start: { x: 280, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275 },
        end: { x: 292, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })

      // diagonal 3
      currentPage.drawLine({
        start: { x: 360, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 275 },
        end: { x: 372, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })


      // diagonal 4
      currentPage.drawLine({
        start: { x: 188, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 315 },
        end: { x: 200, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })

      // diagonal 5
      currentPage.drawLine({
        start: { x: 280, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 315 },
        end: { x: 292, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })

      // diagonal 6
      currentPage.drawLine({
        start: { x: 360, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 315 },
        end: { x: 372, y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 295 },
        thickness: 1,
        color: rgb(0, 0, 0),
        opacity: 0.55,
      })


    }

    if (retanguloY - (linhasAcaoContencao.length * lineHeight) - 324 < 70) {
      currentPage = pdfDoc.addPage(); // Adiciona uma nova página
      /*     currentPageHeight = currentPage.getHeight(); // Reinicializa a altura da nova página */
      retanguloY = 975;

      pageCount++;
      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });




      // linha 12 A

      if (checkMedicao) {
        currentPage.drawRectangle({
          x: 180,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 180,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Medição', {
        x: 190,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 324,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });




      if (checkMetodo) {
        currentPage.drawRectangle({
          x: 272,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 272,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Método', {
        x: 282,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 324,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });



      if (checkMeioAmbiente) {
        currentPage.drawRectangle({
          x: 352,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 352,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Meio ambiente', {
        x: 362,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 324,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

    } else {

      // linha 12 A

      if (checkMedicao) {
        currentPage.drawRectangle({
          x: 180,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 180,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Medição', {
        x: 190,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 324,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });



      if (checkMetodo) {
        currentPage.drawRectangle({
          x: 272,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 272,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Método', {
        x: 282,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 324,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });



      if (checkMeioAmbiente) {
        currentPage.drawRectangle({
          x: 352,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(0, 0, 0),
        });
      } else {
        currentPage.drawRectangle({
          x: 352,
          y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 325,
          width: 8,
          height: 8,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
      }

      currentPage.drawText('Meio ambiente', {
        x: 362,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 324,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

    }


    if (retanguloY - (linhasAcaoContencao.length * lineHeight) - 355 - 10 < 70 || retanguloY - (linhasAcaoContencao.length * lineHeight) - 345 - 10 < 70 || retanguloY - (linhasAcaoContencao.length * lineHeight) - 340 - 10 < 70) {
      currentPage = pdfDoc.addPage(); // Adiciona uma nova página
      /*     currentPageHeight = currentPage.getHeight(); // Reinicializa a altura da nova página */
      retanguloY = 935;
      pageCount++;
      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });


      const retanguloYDescricaoProblema = retanguloY - (linhasAcaoContencao.length * lineHeight) - 300 - 10;
      currentPage.drawRectangle({
        x: 30,
        y: retanguloYDescricaoProblema - retanguloAltura1, // Ajuste a posição vertical
        width: 535,
        height: retanguloAltura1 + 20, // Ajuste de 10 unidades para espaçamento vertical
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Efeito:', {
        x: 35,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 300 - 10,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      const inicioDescricaoProblemaY = retanguloY - (linhasAcaoContencao.length * lineHeight) - 315 - 10; // Ajuste para o texto fique dentro do retângulo
      linhasDescricaoProblema.forEach((linha, index) => {
        // const y = inicioDescricaoProblemaY - (index * lineHeight); // Ajuste para que o texto fique dentro do retângulo

        if (inicioDescricaoProblemaY - (index * lineHeight) < 70) {
          // Crie uma nova página
          currentPage = pdfDoc.addPage([595, 842]);

          //  currentPageHeight7 = 842; // Redefina a altura da nova página
          retanguloY = 935; // Atualize o valor retanguloY para a nova página
          pageCount++;
          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawText(linha || "", {
          x: 35,
          y: inicioDescricaoProblemaY - (index * lineHeight),
          //y,
          size: fontSize,
          font: arialFont,
          color: textColor,
        });
      });

      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

    } else {

      const retanguloYDescricaoProblema = retanguloY - (linhasAcaoContencao.length * lineHeight) - 345 - 10;
      currentPage.drawRectangle({
        x: 30,
        y: retanguloYDescricaoProblema - retanguloAltura1, // Ajuste a posição vertical
        width: 535,
        height: retanguloAltura1 + 20, // Ajuste de 10 unidades para espaçamento vertical
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Efeito:', {
        x: 35,
        y: retanguloY - (linhasAcaoContencao.length * lineHeight) - 340 - 10,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      const inicioDescricaoProblemaY = retanguloY - (linhasAcaoContencao.length * lineHeight) - 355 - 10; // Ajuste para o texto fique dentro do retângulo
      linhasDescricaoProblema.forEach((linha, index) => {
        const y = inicioDescricaoProblemaY - (index * lineHeight); // Ajuste para que o texto fique dentro do retângulo


        currentPage.drawText(linha || "", {
          x: 35,
          y,
          size: fontSize,
          font: arialFont,
          color: textColor,
        });
      });

    }

    //99999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999

    if (retanguloY - (linhasAcaoContencao.length * lineHeight) - 440 < 70) {
      currentPage = pdfDoc.addPage(); // Adiciona uma nova página
      /*     currentPageHeight = currentPage.getHeight(); // Reinicializa a altura da nova página */

      pageCount++;

      currentPage.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

      retanguloY = 1270;


      let yPosition = retanguloY - (linhasAcaoContencao.length * lineHeight) - 440;




      /*    currentPage.drawText(materiaPrima || "", {
           x: 100,
           y: yPosition,
           size: 9,
           font: arialFont,
           color: rgb(0, 0, 0),
         }); */


      const maxCharactersPerLine = 95;

      if (checkMateriaPrima) {
        const lines2 = splitTextIntoLines(materiaPrima || "", maxCharactersPerLine);
        const textHeight2 = lines2.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight2 - 10,
          width: 535,
          height: textHeight2 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Matéria-prima:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines2) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight2,
              width: 535,
              height: textHeight2 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });

          }

          currentPage.drawText(line || "", {
            x: 100,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }


      if (!checkMateriaPrima) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Matéria-prima:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };

      if (checkMaquina) {
        const lines3 = splitTextIntoLines(maquina || "", maxCharactersPerLine);
        const textHeight3 = lines3.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight3 - 10,
          width: 535,
          height: textHeight3 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Máquina:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines3) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight3,
              width: 535,
              height: textHeight3 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });

          }

          currentPage.drawText(line || "", {
            x: 80,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }

      if (!checkMaquina) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Máquina:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };

      if (checkMaoDeObra) {
        const lines4 = splitTextIntoLines(maoDeObra || "", maxCharactersPerLine);
        const textHeight4 = lines4.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight4 - 10,
          width: 535,
          height: textHeight4 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Mão de obra:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines4) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight4,
              width: 535,
              height: textHeight4 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });

          }

          currentPage.drawText(line || "", {
            x: 95,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }

      if (!checkMaoDeObra) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Mão-de-obra:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };


      if (checkMedicao) {
        const lines5 = splitTextIntoLines(medicao || "", maxCharactersPerLine);
        const textHeight5 = lines5.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight5 - 10,
          width: 535,
          height: textHeight5 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Medição:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines5) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight5,
              width: 535,
              height: textHeight5 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 80,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }
      if (!checkMedicao) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });
        currentPage.drawText('Medição:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };


      if (checkMetodo) {
        const lines6 = splitTextIntoLines(metodo || "", maxCharactersPerLine);
        const textHeight6 = lines6.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight6 - 10,
          width: 535,
          height: textHeight6 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Método:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines6) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight6,
              width: 535,
              height: textHeight6 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 75,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }
      if (!checkMetodo) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Método:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };




      if (checkMeioAmbiente) {
        const lines77 = splitTextIntoLines(meioAmbiente || "", maxCharactersPerLine);
        const textHeight77 = lines77.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight77 - 10,
          width: 535,
          height: textHeight77 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Meio Ambiente:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines77) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight77,
              width: 535,
              height: textHeight77 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 110,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }
      if (!checkMeioAmbiente) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Meio ambiente:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };






      currentPage.drawText('Cinco Porquês', {
        x: 271,
        y: yPosition - 30,
        size: 10, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      yPosition -= 13;

      currentPage.drawText(' Porque a não conformidade ocorreu?', {
        x: 240,
        y: yPosition - 32,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      yPosition -= 13;

      if (yPosition - 30 < 70 || yPosition - 40 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        yPosition = 1245;
        pageCount++;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }


      let yPositionPorque = yPosition - 35;




      if (porque1 !== "") {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque1 || "", maxCharactersPerLine);

        const textHeight = lines.length * (fontSize + 2);

        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 780;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });


        currentPage.drawText('1° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });


        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            pageCount++;


            yPositionPorque = 780;

            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight + 90,
              width: 535,
              height: textHeight - 70,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;

        }




      } else { }

      // Para o 2° Porquê (porque2)
      if (porque2 && porque2.trim().length > 0) {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque2 || "", maxCharactersPerLine);

        const textHeight = lines.length * (fontSize + 2);

        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 780;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('2° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        //let yPositionPorque = height - 50 - 20; // Inicie na parte inferior do retângulo
        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            pageCount++;


            yPositionPorque = 780;

            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight + 75,
              width: 535,
              height: textHeight - 70,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });

          }
          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }
      } else { }

      if (porque3 && porque3.trim().length > 0) {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque3 || "", maxCharactersPerLine);

        const textHeight = lines.length * (fontSize + 2);

        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 780;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('3° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        //let yPositionPorque = height - 50 - 20; // Inicie na parte inferior do retângulo
        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);

            pageCount++;

            yPositionPorque = 780;

            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight + 75,
              width: 535,
              height: textHeight - 70,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }
      } else { }


      if (porque4 && porque4.trim().length > 0) {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque4 || "", maxCharactersPerLine);
        const textHeight = lines.length * (fontSize + 2);

        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 780;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('4° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        //let yPositionPorque = height - 50 - 20; // Inicie na parte inferior do retângulo
        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            pageCount++;


            yPositionPorque = 780;

            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - 40,
              width: 535,
              height: textHeight + 10,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }
      } else { }


      if (porque5 && porque5.trim().length > 0) {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque5 || "", maxCharactersPerLine);
        const textHeight = lines.length * (fontSize + 2);

        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 780;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });


        currentPage.drawText('5° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            pageCount++;


            yPositionPorque = 750;

            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight + 75,
              width: 535,
              height: textHeight - 70,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }
      } else { }


      const maxCharactersPerLine2 = 120;
      const lines = splitTextIntoLines(descCausaIdentificada || "", maxCharactersPerLine2);

      const textHeight = lines.length * (fontSize + 2);

      if (yPositionPorque - textHeight - 80 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        pageCount++;
        yPositionPorque = 750;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }

      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - textHeight - 80,
        width: 535,
        height: textHeight + 40, // You may need to adjust this height
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      if (yPositionPorque - 57 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        pageCount++;
        yPositionPorque = 820;
        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }


      currentPage.drawText('Descrição da causa raiz identificada:', {
        x: 35,
        y: yPositionPorque - 57,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      })



      for (const line of lines) {
        if (yPositionPorque - 70 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;


          // retanguloY = 935; // Atualize o valor retanguloY para a nova página
          yPositionPorque = 750;
          currentPage.drawRectangle({
            x: 30,
            y: yPositionPorque - textHeight - 5,
            width: 535,
            height: textHeight + 10, // You may need to adjust this height
            borderColor: rgb(0, 0, 0),
            borderWidth: 1,
            color: rgb(1, 1, 1),
          });

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }
        currentPage.drawText(line || "", {
          x: 35,
          y: yPositionPorque - 70, // Adjust this value as needed
          size: fontSize,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
        yPositionPorque -= fontSize + 4;
      }


      //77777777777777777777777777777777777777


      const maxCharactersPerLine5 = 110;
      const lines9 = splitTextIntoLines(descAnaliseDeRisco || "", maxCharactersPerLine5);

      const textHeight9 = lines9.length * (fontSize + 2);

      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - textHeight9 - 150,
        width: 535,
        height: textHeight9 + 60, // You may need to adjust this height
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Análise de risco e oportunidades', {
        x: 215,
        y: yPositionPorque - 107,
        size: 10,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText('Existe necessidade de alteração de risco e oportunidades?', {
        x: 165,
        y: yPositionPorque - 125,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText(analiseDeRisco || "", {
        x: 420,
        y: yPositionPorque - 125,
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText('Descrição:', {
        x: 35,
        y: yPositionPorque - 144,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });


      if (analiseDeRisco === 'sim') {
        for (const line of lines9) {
          if (yPositionPorque - 144 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPositionPorque = 900;
            pageCount++;



            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight9 - 115,
              width: 535,
              height: textHeight9 - 5, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 82,
            y: yPositionPorque - 144, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }

      } else {
        currentPage.drawText('Não se aplica', {
          x: 82,
          y: yPositionPorque - 144,
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }

      if (yPositionPorque - 200 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        yPositionPorque = 1000;
        pageCount++;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }



      currentPage.drawText('Ação Corretiva', {
        x: 265,
        y: yPositionPorque - 200,
        size: 10,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });



      const lines11 = splitTextIntoLines(descAplicavelSetores || "", maxCharactersPerLine);

      const textHeight11 = lines11.length * (fontSize + 2);

      if (yPositionPorque - 276 < 90) {
        currentPage = pdfDoc.addPage([595, 842]);
        yPositionPorque = 1000;
        pageCount++;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }

      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - textHeight11 - 280,
        width: 535,
        height: textHeight11 + 50, // You may need to adjust this height
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText(acaoCorretiva || "", {
        x: 295,
        y: yPositionPorque - 247,
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });




      currentPage.drawText('Aplicável a outros setores?', {
        x: 235,
        y: yPositionPorque - 260,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText(aplicAvelSetores || "", {
        x: 360,
        y: yPositionPorque - 260,
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText('Descrição:', {
        x: 35,
        y: yPositionPorque - 276,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });


      if (aplicAvelSetores === 'sim') {
        for (const line of lines11) {
          if (yPositionPorque - 276 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPositionPorque = 1030;
            pageCount++;



            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight11 - 225,
              width: 535,
              height: textHeight11 - 15, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 92,
            y: yPositionPorque - 276, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }

      } else {
        currentPage.drawText('Não se aplica', {
          x: 92,
          y: yPositionPorque - 276,
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }





      const maxCharactersPerLine10 = 105;
      const lines10 = splitTextIntoLines(justAcaoCorretiva || "", maxCharactersPerLine10);

      const textHeight10 = lines10.length * (fontSize + 2);


      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - textHeight10 - 319,
        width: 535,
        height: textHeight10 + 40, // You may need to adjust this height
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });


      if (yPositionPorque - 305 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        yPositionPorque = 1080;
        pageCount++;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }


      currentPage.drawText('Justificativa:', {
        x: 35,
        y: yPositionPorque - 305,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });


      if (acaoCorretiva === 'sim') {
        for (const line of lines10) {
          if (yPositionPorque - 305 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPositionPorque = 1050;
            pageCount++;



            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight10 - 245,
              width: 535,
              height: textHeight10 - 45, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 92,
            y: yPositionPorque - 305, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }


      } else {
        currentPage.drawText('Não se aplica', {
          x: 92,
          y: yPositionPorque - 305,
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }




      currentPage.drawText('Plano de ação', {
        x: 272,
        y: yPositionPorque - 340,
        size: 10,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });


      yPositionPorque -= 260;

      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 40,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('N° ação', {
        x: 33,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawRectangle({
        x: 70,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 190,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Descrição da ação', {
        x: 128,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawRectangle({
        x: 260,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 120,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Responsável pela ação', {
        x: 270,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawRectangle({
        x: 380,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 130,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });


      currentPage.drawText('Previsão de implementação', {
        x: 386,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawRectangle({
        x: 510,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 55,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Conclusão', {
        x: 514,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });




      const totalAcoes = acoes.length;
      const yOffset = 20; // Ajuste de distância
      const initialY = yPositionPorque - 130;

      const pageHeight = 782;

      let n = 0;
      let y = initialY;

      while (n < totalAcoes) {
        // Verifique se é necessário criar uma nova página
        if (y - yOffset < 70) {
          currentPage = pdfDoc.addPage();
          y = pageHeight - yOffset; // Redefina a posição Y na nova página
          pageCount++;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });

        }

        const columnData3 = [
          { x: 30, width: 40, text: acoes[n].item1 || "" },
          { x: 70, width: 190, text: acoes[n].acao1 || "" },
          { x: 260, width: 120, text: acoes[n].responsavelAcao1 || "" },
          { x: 380, width: 130, text: moment(acoes[n].previsaoAcao1).format('DD/MM/YYYY') || "" },
          { x: 510, width: 55, text: acoes[n].execucaoAcao1 !== "" ? moment(acoes[n].execucaoAcao1).format('DD/MM/YYYY') : "" },
        ];

        for (const column of columnData3) {
          currentPage.drawRectangle({
            x: column.x,
            y: y, // Ajuste para reduzir a distância
            width: column.width,
            height: 20,
            borderColor: rgb(0, 0, 0),
            borderWidth: 1,
            color: rgb(1, 1, 1),
          });
          const textX = column.x + (column.width / 2) - (column.text.length * 2.3);
          currentPage.drawText(column.text, {

            x: textX, // Ajuste para alinhar o texto dentro do retângulo
            y: y + 5, // Ajuste para alinhar o texto verticalmente no retângulo
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }
        y -= yOffset;
        n++;
      }








      const reducedDistance = 50;



      currentPage.drawText('Verificação de eficácia', {
        x: 255,
        y: y - reducedDistance + 35, // Ajuste para a posição do título
        size: 10,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      const columnDataX = [
        { x: 30, width: 70, text: 'Prazo' },
        { x: 100, width: 170, text: 'Responsável pela verificação' },
        { x: 270, width: 110, text: 'Data de verificação' },
        { x: 380, width: 185, text: 'Observação' },
      ];

      for (const column of columnDataX) {
        currentPage.drawRectangle({
          x: column.x,
          y: y - reducedDistance, // Ajuste para reduzir a distância
          width: column.width,
          height: 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });
        const textX = column.x + (column.width / 2) - (column.text.length * 2.3);
        currentPage.drawText(column.text, {

          x: textX, // Ajuste para alinhar o texto dentro do retângulo
          y: y - reducedDistance + 5, // Ajuste para alinhar o texto verticalmente no retângulo
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        if (y - reducedDistance + 5 < 155 || y - reducedDistance < 155 || y - reducedDistance + 35 < 150) {
          // Se a coordenada y2 for menor que 150, mude para uma nova página
          currentPage = pdfDoc.addPage([595, 842]); // Crie uma nova página (tamanho padrão A4)
          y = 800; // Redefina o valor de y2 para a nova página
          pageCount++;
          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

      }


      const totalVerifica = verificaEficacia.length;
      var n2 = 0;

      let y2 = y - 70 - n2 * 20; // Valor inicial de y2


      //let n2 = 0;
      while (n2 < totalVerifica) {

        if (y2 < 150) {
          // Se a coordenada y2 for menor que 150, mude para uma nova página
          currentPage = pdfDoc.addPage([595, 842]); // Crie uma nova página (tamanho padrão A4)
          y2 = 802; // Redefina o valor de y2 para a nova página
          pageCount++;
          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });

        }

        const columnData2 = [

          { x: 30, width: 70, text: verificaEficacia[n2].verResponsavelAcao1 !== "" ? verificaEficacia[n2].verPrevisaoAcao1 : '' },
          { x: 100, width: 170, text: verificaEficacia[n2].verResponsavelAcao1 || "" },
          { x: 270, width: 110, text: verificaEficacia[n2].verResponsavelAcao1 !== "" ? moment(verificaEficacia[n2].verExecucaoAcao1).format('DD/MM/YYYY') || "" : '' },
          { x: 380, width: 185, text: verificaEficacia[n2].verComentario1 || "" },
        ];

        for (const column of columnData2) {
          /* if(verificaEficacia[n2].verAcao1 !==""){ */
          currentPage.drawRectangle({
            x: column.x,
            y: y2, // Ajuste para reduzir a distância
            width: column.width,
            height: 20,
            borderColor: rgb(0, 0, 0),
            borderWidth: 1,
            color: rgb(1, 1, 1),
          });/* }else{} */
          const textX = column.x + (column.width / 2) - (column.text.length * 2.3);

          /* if(verificaEficacia[n2].verAcao1 !==""){ */
          currentPage.drawText(column.text || "", {

            x: textX, // Ajuste para alinhar o texto dentro do retângulo
            y: y2 + 5, // Ajuste para alinhar o texto verticalmente no retângulo
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          /* }else{} */
        }

        // Atualize o valor de y2
        y2 -= 20;
        n2++;
      }
      /*    while (n2 > totalVerifica) {currentPage.drawRectangle({
          x: 190,
          y: 190, // Ajuste para reduzir a distância
          width: 1,
          height: 1,
          borderColor: rgb(1, 1, 1),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });}  */




      //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
      //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
      //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    } else {

      let yPosition = retanguloY - (linhasAcaoContencao.length * lineHeight) - 400;






      const maxCharactersPerLine = 95;

      if (checkMateriaPrima) {
        const lines2 = splitTextIntoLines(materiaPrima || "", maxCharactersPerLine);
        const textHeight2 = lines2.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight2 - 10,
          width: 535,
          height: textHeight2 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Matéria-prima:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines2) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight2,
              width: 535,
              height: textHeight2 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });

          }

          currentPage.drawText(line || "", {
            x: 100,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }


      if (!checkMateriaPrima) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Matéria-prima:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };

      if (checkMaquina) {
        const lines3 = splitTextIntoLines(maquina || "", maxCharactersPerLine);
        const textHeight3 = lines3.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight3 - 10,
          width: 535,
          height: textHeight3 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Máquina:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines3) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight3,
              width: 535,
              height: textHeight3 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });

          }

          currentPage.drawText(line || "", {
            x: 80,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }

      if (!checkMaquina) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Máquina:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };

      if (checkMaoDeObra) {
        const lines4 = splitTextIntoLines(maoDeObra || "", maxCharactersPerLine);
        const textHeight4 = lines4.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight4 - 10,
          width: 535,
          height: textHeight4 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Mão de obra:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines4) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight4,
              width: 535,
              height: textHeight4 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });

          }

          currentPage.drawText(line || "", {
            x: 95,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }

      if (!checkMaoDeObra) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Mão-de-obra:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };


      if (checkMedicao) {
        const lines5 = splitTextIntoLines(medicao || "", maxCharactersPerLine);
        const textHeight5 = lines5.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight5 - 10,
          width: 535,
          height: textHeight5 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Medição:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines5) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight5,
              width: 535,
              height: textHeight5 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 80,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }
      if (!checkMedicao) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });
        currentPage.drawText('Medição:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };


      if (checkMetodo) {
        const lines6 = splitTextIntoLines(metodo || "", maxCharactersPerLine);
        const textHeight6 = lines6.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight6 - 10,
          width: 535,
          height: textHeight6 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Método:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines6) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight6,
              width: 535,
              height: textHeight6 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 75,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }
      if (!checkMetodo) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Método:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };




      if (checkMeioAmbiente) {
        const lines77 = splitTextIntoLines(meioAmbiente || "", maxCharactersPerLine);
        const textHeight77 = lines77.length * (fontSize + 2);

        currentPage.drawRectangle({
          x: 30,
          y: yPosition - textHeight77 - 10,
          width: 535,
          height: textHeight77 + 20, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Meio Ambiente:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines77) {
          if (yPosition < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPosition = 825;
            pageCount++;

            currentPage.drawRectangle({
              x: 30,
              y: yPosition - textHeight77,
              width: 535,
              height: textHeight77 + 60, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 110,
            y: yPosition, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPosition -= 14;
        }
      }
      if (!checkMeioAmbiente) {
        currentPage.drawRectangle({
          x: 30,
          y: yPosition - 9,
          width: 535,
          height: 19, // You may need to adjust this height
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('Meio ambiente:', {
          x: 35,
          y: yPosition,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        yPosition -= 19;
      };






      currentPage.drawText('Cinco Porquês', {
        x: 271,
        y: yPosition - 30,
        size: 10, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      yPosition -= 13;

      currentPage.drawText(' Porque a não conformidade ocorreu?', {
        x: 240,
        y: yPosition - 32,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      yPosition -= 13;

      if (yPosition - 30 < 70 || yPosition - 40 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        yPosition = 825;
        pageCount++;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }


      let yPositionPorque = yPosition - 35;




      if (porque1 !== "") {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque1 || "", maxCharactersPerLine);

        const textHeight = lines.length * (fontSize + 2);

        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 800;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });


        currentPage.drawText('1° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });


        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            pageCount++;


            yPositionPorque = 750;

            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight + 90,
              width: 535,
              height: textHeight - 70,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;

        }




      } else { }

      // Para o 2° Porquê (porque2)
      if (porque2 && porque2.trim().length > 0) {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque2 || "", maxCharactersPerLine);

        const textHeight = lines.length * (fontSize + 2);


        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 780;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }


        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('2° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        //let yPositionPorque = height - 50 - 20; // Inicie na parte inferior do retângulo
        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            pageCount++;


            yPositionPorque = 780;

            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight + 75,
              width: 535,
              height: textHeight - 70,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });

          }
          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }
      } else { }

      if (porque3 && porque3.trim().length > 0) {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque3 || "", maxCharactersPerLine);

        const textHeight = lines.length * (fontSize + 2);

        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 780;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });

        currentPage.drawText('3° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        //let yPositionPorque = height - 50 - 20; // Inicie na parte inferior do retângulo
        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);

            pageCount++;

            yPositionPorque = 780;


            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - 50,
              width: 535,
              height: textHeight + 10,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }
      } else { }


      if (porque4 && porque4.trim().length > 0) {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque4 || "", maxCharactersPerLine);
        const textHeight = lines.length * (fontSize + 2);

        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 780;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });


        currentPage.drawText('4° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        //let yPositionPorque = height - 50 - 20; // Inicie na parte inferior do retângulo
        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            pageCount++;


            yPositionPorque = 750;

            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - 20,
              width: 535,
              height: textHeight + 20,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }
      } else { }


      if (porque5 && porque5.trim().length > 0) {
        const maxCharactersPerLine = 105;
        const lines = splitTextIntoLines(porque5 || "", maxCharactersPerLine);
        const textHeight = lines.length * (fontSize + 2);


        if (yPositionPorque - 10 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;
          yPositionPorque = 780;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

        currentPage.drawRectangle({
          x: 30,
          y: yPositionPorque - textHeight - 20,
          width: 535,
          height: textHeight + 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });



        currentPage.drawText('5° Porquê:', {
          x: 35,
          y: yPositionPorque - 10,
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        for (const line of lines) {
          if (yPositionPorque - 10 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            pageCount++;


            yPositionPorque = 750;

            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight - 20,
              width: 535,
              height: textHeight + 20,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });
            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 85,
            y: yPositionPorque - 10,
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }
      } else { }


      const maxCharactersPerLine2 = 120;
      const lines = splitTextIntoLines(descCausaIdentificada || "", maxCharactersPerLine2);

      const textHeight = lines.length * (fontSize + 2);

      if (yPositionPorque - textHeight - 80 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        pageCount++;
        yPositionPorque = 750;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }

      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - textHeight - 80,
        width: 535,
        height: textHeight + 40, // You may need to adjust this height
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      if (yPositionPorque - 57 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        pageCount++;
        yPositionPorque = 820;
        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }


      currentPage.drawText('Descrição da causa raiz identificada:', {
        x: 35,
        y: yPositionPorque - 57,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      })



      for (const line of lines) {
        if (yPositionPorque - 70 < 70) {
          currentPage = pdfDoc.addPage([595, 842]);
          pageCount++;


          // retanguloY = 935; // Atualize o valor retanguloY para a nova página
          yPositionPorque = 750;
          currentPage.drawRectangle({
            x: 30,
            y: yPositionPorque - textHeight - 5,
            width: 535,
            height: textHeight + 10, // You may need to adjust this height
            borderColor: rgb(0, 0, 0),
            borderWidth: 1,
            color: rgb(1, 1, 1),
          });

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }
        currentPage.drawText(line || "", {
          x: 35,
          y: yPositionPorque - 70, // Adjust this value as needed
          size: fontSize,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
        yPositionPorque -= fontSize + 4;
      }


      //77777777777777777777777777777777777777


      const maxCharactersPerLine5 = 110;
      const lines9 = splitTextIntoLines(descAnaliseDeRisco || "", maxCharactersPerLine5);

      const textHeight9 = lines9.length * (fontSize + 2);

      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - textHeight9 - 150,
        width: 535,
        height: textHeight9 + 60, // You may need to adjust this height
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Análise de risco e oportunidades', {
        x: 215,
        y: yPositionPorque - 107,
        size: 10,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText('Existe necessidade de alteração de risco e oportunidades?', {
        x: 165,
        y: yPositionPorque - 125,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText(analiseDeRisco || "", {
        x: 420,
        y: yPositionPorque - 125,
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText('Descrição:', {
        x: 35,
        y: yPositionPorque - 144,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });


      if (analiseDeRisco === 'sim') {
        for (const line of lines9) {
          if (yPositionPorque - 144 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPositionPorque = 900;
            pageCount++;



            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight9 - 115,
              width: 535,
              height: textHeight9 - 5, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 82,
            y: yPositionPorque - 144, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }

      } else {
        currentPage.drawText('Não se aplica', {
          x: 82,
          y: yPositionPorque - 144,
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }

      if (yPositionPorque - 200 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        yPositionPorque = 1000;
        pageCount++;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }



      currentPage.drawText('Ação Corretiva', {
        x: 265,
        y: yPositionPorque - 200,
        size: 10,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });



      const lines11 = splitTextIntoLines(descAplicavelSetores || "", maxCharactersPerLine);

      const textHeight11 = lines11.length * (fontSize + 2);

      if (yPositionPorque - 276 < 90) {
        currentPage = pdfDoc.addPage([595, 842]);
        yPositionPorque = 1000;
        pageCount++;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }

      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - textHeight11 - 280,
        width: 535,
        height: textHeight11 + 50, // You may need to adjust this height
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText(acaoCorretiva || "", {
        x: 295,
        y: yPositionPorque - 247,
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });




      currentPage.drawText('Aplicável a outros setores?', {
        x: 235,
        y: yPositionPorque - 260,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText(aplicAvelSetores || "", {
        x: 360,
        y: yPositionPorque - 260,
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawText('Descrição:', {
        x: 35,
        y: yPositionPorque - 276,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });


      if (aplicAvelSetores === 'sim') {
        for (const line of lines11) {
          if (yPositionPorque - 276 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPositionPorque = 1030;
            pageCount++;



            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight11 - 225,
              width: 535,
              height: textHeight11 - 15, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }
          currentPage.drawText(line || "", {
            x: 92,
            y: yPositionPorque - 276, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }

      } else {
        currentPage.drawText('Não se aplica', {
          x: 92,
          y: yPositionPorque - 276,
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }





      const maxCharactersPerLine10 = 105;
      const lines10 = splitTextIntoLines(justAcaoCorretiva || "", maxCharactersPerLine10);

      const textHeight10 = lines10.length * (fontSize + 2);


      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - textHeight10 - 319,
        width: 535,
        height: textHeight10 + 40, // You may need to adjust this height
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });


      if (yPositionPorque - 305 < 70) {
        currentPage = pdfDoc.addPage([595, 842]);
        yPositionPorque = 1080;
        pageCount++;

        currentPage.drawText(`Página ${pageCount} `, {
          x: 505, // Ajuste as coordenadas conforme necessário
          y: 5,  // Ajuste as coordenadas conforme necessário
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }


      currentPage.drawText('Justificativa:', {
        x: 35,
        y: yPositionPorque - 305,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });


      if (acaoCorretiva === 'nao') {
        for (const line of lines10) {
          if (yPositionPorque - 305 < 70) {
            currentPage = pdfDoc.addPage([595, 842]);
            yPositionPorque = 1050;
            pageCount++;



            currentPage.drawRectangle({
              x: 30,
              y: yPositionPorque - textHeight10 - 245,
              width: 535,
              height: textHeight10 - 45, // You may need to adjust this height
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
              color: rgb(1, 1, 1),
            });

            currentPage.drawText(`Página ${pageCount} `, {
              x: 505, // Ajuste as coordenadas conforme necessário
              y: 5,  // Ajuste as coordenadas conforme necessário
              size: 9,
              font: arialFont,
              color: rgb(0, 0, 0),
            });
          }

          currentPage.drawText(line || "", {
            x: 92,
            y: yPositionPorque - 305, // Adjust this value as needed
            size: fontSize,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
          yPositionPorque -= fontSize + 4;
        }


      } else {
        currentPage.drawText('Não se aplica', {
          x: 92,
          y: yPositionPorque - 305,
          size: 9,
          font: arialFont,
          color: rgb(0, 0, 0),
        });
      }




      currentPage.drawText('Plano de ação', {
        x: 272,
        y: yPositionPorque - 350,
        size: 10,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });


      yPositionPorque -= 270;

      currentPage.drawRectangle({
        x: 30,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 40,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('N° ação', {
        x: 33,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawRectangle({
        x: 70,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 190,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Descrição da ação', {
        x: 128,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawRectangle({
        x: 260,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 120,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Responsável pela ação', {
        x: 270,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawRectangle({
        x: 380,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 130,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });


      currentPage.drawText('Previsão de implementação', {
        x: 386,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      currentPage.drawRectangle({
        x: 510,
        y: yPositionPorque - 110, // Ajuste para reduzir a distância
        width: 55,
        height: 20,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: rgb(1, 1, 1),
      });

      currentPage.drawText('Conclusão', {
        x: 514,
        y: yPositionPorque - 105,
        size: 9,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });




      const totalAcoes = acoes.length;
      const yOffset = 20; // Ajuste de distância
      const initialY = yPositionPorque - 130;

      const pageHeight = 842;

      let n = 0;
      let y = initialY;

      while (n < totalAcoes) {
        // Verifique se é necessário criar uma nova página
        if (y - yOffset < 70) {
          currentPage = pdfDoc.addPage();
          y = pageHeight - yOffset; // Redefina a posição Y na nova página
          pageCount++;

          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });

        }

        const columnData3 = [
          { x: 30, width: 40, text: acoes[n].item1 || "" },
          { x: 70, width: 190, text: acoes[n].acao1 || "" },
          { x: 260, width: 120, text: acoes[n].responsavelAcao1 || "" },
          { x: 380, width: 130, text: moment(acoes[n].previsaoAcao1).format('DD/MM/YYYY') || "" },
          { x: 510, width: 55, text: acoes[n].execucaoAcao1 !== "" ? moment(acoes[n].execucaoAcao1).format('DD/MM/YYYY') : "" },
        ];

        for (const column of columnData3) {
          currentPage.drawRectangle({
            x: column.x,
            y: y, // Ajuste para reduzir a distância
            width: column.width,
            height: 20,
            borderColor: rgb(0, 0, 0),
            borderWidth: 1,
            color: rgb(1, 1, 1),
          });
          const textX = column.x + (column.width / 2) - (column.text.length * 2.3);
          currentPage.drawText(column.text, {

            x: textX, // Ajuste para alinhar o texto dentro do retângulo
            y: y + 5, // Ajuste para alinhar o texto verticalmente no retângulo
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }
        y -= yOffset;
        n++;
      }




      const reducedDistance = 50;



      currentPage.drawText('Verificação de eficácia', {
        x: 255,
        y: y - reducedDistance + 35, // Ajuste para a posição do título
        size: 10,
        font: arialBoldFont,
        color: rgb(0, 0, 0),
      });

      const columnDataX = [
        { x: 30, width: 70, text: 'Prazo' },
        { x: 100, width: 170, text: 'Responsável pela verificação' },
        { x: 270, width: 110, text: 'Data de verificação' },
        { x: 380, width: 185, text: 'Observação' },
      ];

      for (const column of columnDataX) {
        currentPage.drawRectangle({
          x: column.x,
          y: y - reducedDistance, // Ajuste para reduzir a distância
          width: column.width,
          height: 20,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
          color: rgb(1, 1, 1),
        });
        const textX = column.x + (column.width / 2) - (column.text.length * 2.3);
        currentPage.drawText(column.text || "", {

          x: textX, // Ajuste para alinhar o texto dentro do retângulo
          y: y - reducedDistance + 5, // Ajuste para alinhar o texto verticalmente no retângulo
          size: 9,
          font: arialBoldFont,
          color: rgb(0, 0, 0),
        });

        if (y - reducedDistance + 5 < 155 || y - reducedDistance < 155 || y - reducedDistance + 35 < 150) {
          // Se a coordenada y2 for menor que 150, mude para uma nova página
          currentPage = pdfDoc.addPage([595, 842]); // Crie uma nova página (tamanho padrão A4)
          y = 800; // Redefina o valor de y2 para a nova página
          pageCount++;
          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });
        }

      }


      const totalListaVerifica = listaVerificaEficacia.length;
      let n3 = 0;
      let y3 = y - 70 - n3 * 20; // Valor inicial de y2

      while (n3 < totalListaVerifica) {

        if (y3 < 150) {
          // Se a coordenada y2 for menor que 150, mude para uma nova página
          currentPage = pdfDoc.addPage([595, 842]); // Crie uma nova página (tamanho padrão A4)
          y3 = 802; // Redefina o valor de y2 para a nova página
          pageCount++;
          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });

        }

        const columnData2x = [

          { x: 30, width: 70, text: listaVerificaEficacia[n3].verResponsavelAcao1 !== "" ? listaVerificaEficacia[n3].verPrevisaoAcao1 : '' },
          { x: 100, width: 170, text: listaVerificaEficacia[n3].verResponsavelAcao1 || "" },
          { x: 270, width: 110, text: listaVerificaEficacia[n3].verResponsavelAcao1 !== "" ? moment(listaVerificaEficacia[n3].verExecucaoAcao1).format('DD/MM/YYYY') || "" : '' },
          { x: 380, width: 185, text: listaVerificaEficacia[n3].verComentario1 || "" },
        ];


        for (const column of columnData2x) {

          currentPage.drawRectangle({
            x: column.x,
            y: y3, // Ajuste para reduzir a distância
            width: column.width,
            height: 20,
            borderColor: rgb(0, 0, 0),
            borderWidth: 1,
            color: rgb(1, 1, 1),
          });
          const textX = column.x + (column.width / 2) - (column.text.length * 2.3);

          currentPage.drawText(column.text || "", {
            x: textX, // Ajuste para alinhar o texto dentro do retângulo
            y: y3 + 5, // Ajuste para alinhar o texto verticalmente no retângulo
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
          });



        }

        y3 -= 20;
        n3++;


      }
      /* 
      
      //
      
        }
       
        // Atualize o valor de y2
        y2 -= 20;
        n2++;} */
      /*  while (n2 > totalVerifica) {currentPage.drawRectangle({
       x: 190,
       y: 190, // Ajuste para reduzir a distância
       width: 1,
       height: 1,
       borderColor: rgb(1, 1, 1),
       borderWidth: 1,
       color: rgb(1, 1, 1),
     });}  */








    }




    //1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111




    //RODAPÉ

    currentPage.drawRectangle({
      x: 30,
      y: 130,
      width: 535,
      height: 25,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    currentPage.drawText('Observação:', {
      x: 32,
      y: 145,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });



    currentPage.drawRectangle({
      x: 30,
      y: 88,
      width: 179,
      height: 42,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    currentPage.drawText('Abertura', {
      x: 95,
      y: 120,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    currentPage.drawText('Responsável:', {
      x: 32,
      y: 105,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    if (assinaturaAbertura && assinaturaAbertura.trim() !== '') {
      const imageUrl4 = assinaturaAbertura;
      const imageBytes4 = await fetch(imageUrl4).then(response => response.arrayBuffer());

      // Inserir a imagem na posição desejada
      const image4 = await pdfDoc.embedPng(imageBytes4);
      const imageDims4 = image4.scale(0.1); // Ajuste o fator de escala conforme necessário 

      const rectWidth = 120; // Largura do retângulo
      const rectHeight = 20; // Altura do retângulo

      // Calcule a proporção de escala
      const scaleX = rectWidth / imageDims4.width;
      const scaleY = rectHeight / imageDims4.height;

      // Use a menor proporção de escala para garantir que a imagem caiba completamente dentro do retângulo
      const scale = Math.min(scaleX, scaleY);

      // Calcule a largura e altura da imagem após o dimensionamento
      const scaledWidth = imageDims4.width * scale;
      const scaledHeight = imageDims4.height * scale;

      // Calcule as coordenadas x e y para posicionar a imagem centralizada no retângulo
      const xPosition4 = 70 + (rectWidth - scaledWidth) / 2;
      const yPosition4 = 98 + (rectHeight - scaledHeight) / 2;

      // Desenhe a imagem no PDF apenas se houver uma imagem válida
      currentPage.drawImage(image4 || "", {
        x: xPosition4,
        y: yPosition4,
        width: scaledWidth,
        height: scaledHeight,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      })
    };


    currentPage.drawText('Data:', {
      x: 32,
      y: 92,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    currentPage.drawText(moment(dataAtual).format('DD/MM/YYYY') || "", {
      x: 58,
      y: 92,
      size: 9, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    //88888888888888888888888888888

    currentPage.drawRectangle({
      x: 208,
      y: 88,
      width: 179,
      height: 42,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    currentPage.drawText('Execução', {
      x: 275,
      y: 120,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    currentPage.drawText('Responsável:', {
      x: 210,
      y: 105,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    currentPage.drawText('Data:', {
      x: 210,
      y: 92,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    currentPage.drawText(moment(dataExecutadaPor).format('DD/MM/YYYY') || "", {
      x: 235,
      y: 92,
      size: 9, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });



    if (assinaturaExecucao && assinaturaExecucao.trim() !== '') {
      const imageUrl5 = assinaturaExecucao;
      const imageBytes5 = await fetch(imageUrl5).then(response => response.arrayBuffer());

      // Inserir a imagem na posição desejada
      const image5 = await pdfDoc.embedPng(imageBytes5);
      const imageDims5 = image5.scale(0.1); // Ajuste o fator de escala conforme necessário 

      const rectWidth = 120; // Largura do retângulo
      const rectHeight = 20; // Altura do retângulo

      // Calcule a proporção de escala
      const scaleX = rectWidth / imageDims5.width;
      const scaleY = rectHeight / imageDims5.height;

      // Use a menor proporção de escala para garantir que a imagem caiba completamente dentro do retângulo
      const scale = Math.min(scaleX, scaleY);

      // Calcule a largura e altura da imagem após o dimensionamento
      const scaledWidth = imageDims5.width * scale;
      const scaledHeight = imageDims5.height * scale;

      // Calcule as coordenadas x e y para posicionar a imagem centralizada no retângulo
      const xPosition5 = 248 + (rectWidth - scaledWidth) / 2;
      const yPosition5 = 98 + (rectHeight - scaledHeight) / 2;


      // Desenhe a imagem no PDF apenas se houver uma imagem válida
      currentPage.drawImage(image5 || "", {
        x: xPosition5,
        y: yPosition5,
        width: scaledWidth,
        height: scaledHeight,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      })
    };

    //8888888888888888888888888888888888
    currentPage.drawRectangle({
      x: 386,
      y: 88,
      width: 179,
      height: 42,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    currentPage.drawText('Conclusão', {
      x: 455,
      y: 120,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    currentPage.drawText('Responsável:', {
      x: 388,
      y: 105,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    if (assinaturaEncerramento && assinaturaEncerramento.trim() !== '') {
      const imageUrl3 = assinaturaEncerramento;
      const imageBytes3 = await fetch(imageUrl3).then(response => response.arrayBuffer());

      // Inserir a imagem na posição desejada
      const image3 = await pdfDoc.embedPng(imageBytes3);
      const imageDims3 = image3.scale(0.1); // Ajuste o fator de escala conforme necessário 

      const rectWidth = 120; // Largura do retângulo
      const rectHeight = 20; // Altura do retângulo

      // Calcule a proporção de escala
      const scaleX = rectWidth / imageDims3.width;
      const scaleY = rectHeight / imageDims3.height;

      // Use a menor proporção de escala para garantir que a imagem caiba completamente dentro do retângulo
      const scale = Math.min(scaleX, scaleY);

      // Calcule a largura e altura da imagem após o dimensionamento
      const scaledWidth = imageDims3.width * scale;
      const scaledHeight = imageDims3.height * scale;

      // Calcule as coordenadas x e y para posicionar a imagem centralizada no retângulo

      const xPosition3 = 428 + (rectWidth - scaledWidth) / 2;
      const yPosition3 = 98 + (rectHeight - scaledHeight) / 2;

      // Desenhe a imagem no PDF apenas se houver uma imagem válida
      currentPage.drawImage(image3 || "", {
        x: xPosition3,
        y: yPosition3,
        width: scaledWidth,
        height: scaledHeight,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

    }

    //assinaturaEncerramento

    currentPage.drawText('Data:', {
      x: 388,
      y: 92,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    currentPage.drawText(moment(encerraData).format('DD/MM/YYYY') || "", {
      x: 415,
      y: 92,
      size: 9, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });



    currentPage.drawRectangle({
      x: 30,
      y: 70,
      width: 535,
      height: 18,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });


    /*     currentPage.drawText('Código do laboratório:', {
          x: 35,
          y: 75,
          size: 9, // Tamanho da fonte
          font: arialBoldFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
          }); */



    //
    /*   pageCount++;
          currentPage.drawText(`Página ${pageCount} `, {
            x: 505, // Ajuste as coordenadas conforme necessário
            y: 5,  // Ajuste as coordenadas conforme necessário
            size: 9,
            font: arialFont,
            color: rgb(0, 0, 0),
            }); */

    currentPage.drawText('Data emissão:', {
      x: 250,
      y: 75,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    currentPage.drawText(moment().format('DD/MM/YYYY'), {
      x: 330,
      y: 75,
      size: 9, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });




    currentPage.drawText('Este relatório só pode ser copiado integralmente ou parcialmente com autorização da Geocontrole ', {
      x: 58,
      y: 57,
      size: 10, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    currentPage.drawImage(image2 || "", {
      x: 20,
      y: 5,
      width: 556,
      height: 40,
    });
    currentPage.drawText('www.geocontrole.com - e-mail: mail.br@geocontrole.com ', {
      x: 145,
      y: 24,
      size: 12, // Tamanho da fonte
      font: arialFont,
      color: rgb(1, 1, 1), // Cor do texto (branco)
    });

    currentPage.drawText('Av.Canadá,Nº 159 - Jardim Canadá - Nova Lima - Minas Gerais - Brasil - CEP: 34007-654 Tel.: +55 31 3517-9011 ', {
      x: 45,
      y: 42,
      size: 10, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    // pageCount++;
    currentPage.drawText(`Página ${pageCount} `, {
      x: 505, // Ajuste as coordenadas conforme necessário
      y: 5,  // Ajuste as coordenadas conforme necessário
      size: 9,
      font: arialFont,
      color: rgb(0, 0, 0),
    });



    //555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555


    const pdfBytes = await pdfDoc.save()
    download(pdfBytes, "Rnc-Sgi.pdf", "application/pdf");
    console.log(pdfBytes)
  }
  ;




  function splitTextIntoLines(text, maxLength) {
    const words = text.split(' ');
    const lines = [];
    let currentLine = '';

    for (const word of words) {
      if (currentLine.length + word.length <= maxLength) {
        currentLine += (currentLine.length > 0 ? ' ' : '') + word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }

    if (currentLine.length > 0) {
      lines.push(currentLine);
    }

    return lines;
  }

  const [nprocesso, setNprocesso] = useState();
  const [email, setEmail] = useState();

  async function EnviarEmail() {

    const setorX = ('SGI');

    const res2 = await axios.get(Conexao.api + 'BuscarProtocoloRNCWEB.php');
    setNprocesso(res2.data.pegaProtocolo);



    const res3 = await axios.get(Conexao.api + 'BuscarResponsaveisEmailWEB.php? responsavel2=' + responsavel1);
    setEmail(res3.data.Email);

    console.log('email tratado por  ' + res3.data.Email)

    const res = await axios.get('http://servidor.geocontrole.com/EmailSGI/EmailTratamentoNC.php? email=' + res3.data.Email + '&nprocesso=' + protocolo
      + '&setorOrigem2=' + setorX + '&descricao=' + descricaoproblema);

    if (res.data.success === false) { }
    else { }
  };






  return <div className="home">
     
    <div className="banner" style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto', minHeight: '1600px', minWidth: '1600px' }} >
      <div className="sidebar-button">
        <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
          <div className="icon-container">
            <i className="bi bi-list icon-circle"></i>
          </div>
        </Button>

      </div>
      {/* Bandeiras */}
      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
        </div>

        <div className="sidebar-Text">
        <text style={{ color: '#187A40', fontWeight: 'bold', textShadow: 'none', fontFamily: 'Open Sans, sans-serif', marginLeft: '20%', }}>Investigação de Não Conformidade-INC</text>
      </div>

        <Container>
        <ContainerForm>
        
          <br />
          <hr />
          <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" >
            <div class="col-auto  ">
              <h4  style={{ color: '#000' }}  >RNC</h4>
            </div>
            <div class="col-2  ">
              <input placeholder='Digite o número do protocolo' onChange={(e) => setProtocolo(e.target.value) & Limpar()} onKeyDown={(f) => { if (f.keyCode === 13)
               {
                 getItem(protocolo) 
                 BuscarAcoes(protocolo) 
                 BuscarVerificaEficacia(protocolo) 
                 getSetor(protocolo)
               }
              }} value={protocolo} class="form-control  borda w-100 text-center colorInput"  ></input>
            </div>
            <div class="col-auto ">
              <button class="btnlogin " onClick={(e) => getItem(e) & BuscarAcoes(e) & BuscarVerificaEficacia(e) & getSetor(e)} >BUSCAR</button>
            </div>
          </div>
          <br />
          <hr />
          <div className=' text-center '>
            <h4 style={{ color: '#000' }} >Diagrama de Ishikawa</h4>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" onChange={(f) => setValue("S")} value="yes"></input>
            <label class="form-check-label" for="flexRadioDefault1">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onChange={(f) => setValue("N")} value="no" ></input>
            <label class="form-check-label" for="flexRadioDefault2">
              Não
            </label>
          </div>
          <br/>
          <hr />
          {value === 'S' ?
          <div className="d-flex container-sm  mt-4 ">
            
            <div className="col-4 align-items-center justify-content-center ">

              <h5 className=' text-center ' style={{ color: '#000' }} >Causas Possíveis</h5>

              <br />

              {/*      {!(checkMateriaPrima & checkMaoDeObra & checkMaquina & checkMedicao & checkMeioAmbiente & checkMetodo) ?( 
          <div className="col-2  "> </div>
         ):null} */}




              <div className="d-flex container mt-5 ">

                <div className="col-4 " >
                  <input disabled={bloqueado || block} type="checkbox" className=" me-1" onChange={(e) => setCheckMateriaPrima(e.target.checked)} checked={checkMateriaPrima} />
                  <label className="form-check-label "style={{ color: '#000' }}>Matéria-prima</label>

                  <div className="offset-5 " style={{ width: '58px', height: '2px', backgroundColor: 'gray', transformOrigin: '0 100%', transform: 'rotate(+45deg)', }}></div>
                </div>
                <div className="col-4 ">
                  <input disabled={bloqueado || block} type="checkbox" className=" me-1" onChange={(e) => setCheckMaquina(e.target.checked)} checked={checkMaquina} />
                  <label className="form-check-label"style={{ color: '#000' }}>Máquina</label>
                  <div className="offset-5 " style={{ width: '58px', height: '2px', backgroundColor: 'gray', transformOrigin: '0 100%', transform: 'rotate(+45deg)', }}></div>
                </div>
                <div className="col-4 ">
                  <input disabled={bloqueado || block} type="checkbox" className=" me-1" onChange={(e) => setCheckMaodeObra(e.target.checked)} checked={checkMaoDeObra} />
                  <label className="form-check-label"style={{ color: '#000' }}>Mão de obra</label>
                  <div className="offset-5 " style={{ width: '58px', height: '2px', backgroundColor: 'gray', transformOrigin: '0 100%', transform: 'rotate(+45deg)', }}></div>
                </div>
              </div>
              <br />
              <hr className='mt-3' style={{ borderWidth: '3px' }} />



              <div className="d-flex container mt-4 ">

                <div className="col-4 " >
                  <div className="offset-5 me-3 mt-2 " style={{ width: '58px', height: '2px', backgroundColor: 'gray', transformOrigin: '0 100%', transform: 'rotate(-40deg)', }}></div>
                  <input disabled={bloqueado || block} type="checkbox" className=" me-1 mt-3" onChange={(e) => setCheckMedicao(e.target.checked)} checked={checkMedicao} />
                  <label className="form-check-label"style={{ color: '#000' }}>Medição</label>

                </div>
                <div className="col-4 ">
                  <div className="offset-5 me-3 mt-2 " style={{ width: '58px', height: '2px', backgroundColor: 'gray', transformOrigin: '0 100%', transform: 'rotate(-40deg)', }}></div>
                  <input disabled={bloqueado || block} type="checkbox" className=" me-1 mt-3" onChange={(e) => setCheckMetodo(e.target.checked)} checked={checkMetodo} />
                  <label className="form-check-label"style={{ color: '#000' }}>Método</label>
                </div>
                <div className="col-4 ">
                  <div className="offset-5 me-3 mt-2 " style={{ width: '58px', height: '2px', backgroundColor: 'gray', transformOrigin: '0 100%', transform: 'rotate(-40deg)', }}></div>
                  <input disabled={bloqueado || block} type="checkbox" className=" me-1 mt-3" onChange={(e) => setCheckMeioAmbiente(e.target.checked)} checked={checkMeioAmbiente} />
                  <label className="form-check-label"style={{ color: '#000' }}>Meio ambiente</label>
                </div>
              </div>
            </div>


            <div className="col-8 me-5 align-items-center justify-content-center mt-1 ">
              <h5 className=' text-center 'style={{ color: '#000' }}>Efeito</h5>
              <textarea cols={5} rows={11} className='form-control  borda  colorInput resize' onChange={(e) => setEfeito(e.target.value)} value={descricaoproblema}> </textarea>
            </div>


          </div>
          : null}

          {/*  888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888 */}

          {checkMateriaPrima || checkMaoDeObra || checkMaquina || checkMedicao || checkMeioAmbiente || checkMetodo ? (
            <div className="container align-items-center justify-content-center mt-2">
              {checkMateriaPrima && (
                <div className="container text-center align-items-center mt-3">
                  <div className="d-flex text-center align-items-center">
                    <div className=" col-3">
                      <label className="form-check-label">Matéria-prima</label>
                      <svg onClick={MudaPopUp1} xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="ms-1 bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>
                      {popup1 && (<div className="popup">   Falhas em especificações, fornecedores, conformidade de serviços</div>)}
                    </div>
                    <div className="col-9">
                      <textarea disabled={bloqueado || block} cols={8} rows={2} className="form-control  borda  colorInput resize" onChange={(e) => setMateriaPrima(e.target.value)} value={materiaPrima} ></textarea>
                    </div>
                  </div>
                </div>
              )}
              {checkMaquina && (
                <div className="container mt-3">
                  <div className="d-flex text-center  align-items-center">
                    <div className="col-3">
                      <label className="form-check-label">Máquina</label>
                      <svg onClick={MudaPopUp2} xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="ms-1 bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>
                      {popup2 && (<div className="popup">  Falhas em manutenção, proteção, condições insegura</div>)}
                    </div>
                    <div className="col-9">
                      <textarea disabled={bloqueado || block} cols={8} rows={2} className="form-control  borda  colorInput resize" onChange={(e) => setMaquina(e.target.value)} value={maquina} ></textarea>
                    </div>
                  </div>
                </div>
              )}

              {checkMaoDeObra && (
                <div className="container mt-3">
                  <div className="d-flex text-center  align-items-center">
                    <div className="col-3">
                      <label className="form-check-label">Mão de obra</label>
                      <svg onClick={MudaPopUp3} xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="ms-1 bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>
                      {popup3 && (<div className="popup"> Falhas em treinamentos, motivação, habilidades e avaliação de eficácia de treinamentos.</div>)}
                    </div>
                    <div className="col-9">
                      <textarea disabled={bloqueado || block} cols={8} rows={2} className="form-control  borda  colorInput resize" onChange={(e) => setMaoDeObra(e.target.value)} value={maoDeObra} ></textarea>
                    </div>
                  </div>
                </div>
              )}

              {checkMedicao && (
                <div className="container mt-3">
                  <div className="d-flex text-center align-items-center">
                    <div className="col-3">
                      <label className="form-check-label">Medição</label>
                      <svg onClick={MudaPopUp4} xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="ms-1 bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>
                      {popup4 && (<div className="popup"> Falhas de verificações, inspeções, instrumentos.</div>)}
                    </div>
                    <div className="col-9">
                      <textarea disabled={bloqueado || block} cols={8} rows={2} className="form-control  borda  colorInput resize" onChange={(e) => setMedicao(e.target.value)} value={medicao} ></textarea>
                    </div>
                  </div>
                </div>
              )}

              {checkMetodo && (
                <div className="container mt-3">
                  <div className="d-flex text-center align-items-center">
                    <div className="col-3">
                      <label className="form-check-label">Método</label>
                      <svg onClick={MudaPopUp5} xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="ms-1 bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>
                      {popup5 && (<div className="popup"> Falhas em procedimentos, instruções de trabalho, manuais.</div>)}
                    </div>
                    <div className="col-9">
                      <textarea disabled={bloqueado || block} cols={8} rows={2} className="form-control  borda  colorInput resize" onChange={(e) => setMetodo(e.target.value)} value={metodo} ></textarea>
                    </div>
                  </div>
                </div>
              )}

              {checkMeioAmbiente && (

                <div className="container mt-3">

                  <div className="d-flex text-center align-items-center">

                    <div className="col-3"  >
                      <label className="form-check-label">Meio ambiente</label>

                      <svg onClick={MudaPopUp6} xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="ms-1 bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>

                      {popup6 && (<div className="popup"> Falhas em relação interpessoais, clima, limpeza e organização</div>)}
                    </div>

                    <div className="col-9">
                      <textarea disabled={bloqueado || block} cols={8} rows={2} className="form-control  borda  colorInput resize" onChange={(e) => setMeioAmbiente(e.target.value)} value={meioAmbiente}></textarea>
                    </div>

                  </div>

                </div>
              )}

            </div>
          ) : null}


          {/*  888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888 */}
          <br />
          <hr />


          <div className=' text-center p-2'>
            <h6 style={{ color: '#000' }}>Cinco Porquês</h6>
          </div>

          <br/>
          <hr/>

          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" onChange={(z) => setSucesso("S")} value="yes2"></input>
            <label class="form-check-label" for="flexRadioDefault1">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onChange={(z) => setSucesso("N")} value="no2" ></input>
            <label class="form-check-label" for="flexRadioDefault2">
              Não
            </label>
          </div>
          <br/>
          <hr/>

          {sucesso === 'S' ?
          <body class="container text-center  ">
            <div class="col  align-items-center justify-content-center  ">
              <div class="row d-flex align-items-center justify-content-center ">
                <div class="col-3 mt-4">
                  <h6>Ocorrências</h6>
                  <h6>Porque a não conformidade ocorreu?</h6>
                </div>

                <div class="mt-4 ">
                  <h6>1° Porquê</h6>
                  <textarea disabled={bloqueado || block} cols={7} rows={3} className='form-control  borda colorInput  resize ' value={porque1} onChange={(e) => setPorque1(e.target.value)} ></textarea>
                </div>

                <div class="mt-2">
                  <h6>2° Porquê</h6>
                  <textarea disabled={bloqueado || block} cols={7} rows={3} className='form-control  borda colorInput  resize ' value={porque2} onChange={(e) => setPorque2(e.target.value)}></textarea>
                </div>

                <div class="mt-2">
                  <h6 >3° Porquê</h6>
                  <textarea disabled={bloqueado || block} cols={7} rows={3} className='form-control  borda colorInput  resize ' value={porque3} onChange={(e) => setPorque3(e.target.value)} ></textarea>
                </div>
                <div class="mt-2">
                  <h6 >4° Porquê</h6>
                  <textarea disabled={bloqueado || block} cols={7} rows={3} className='form-control  borda colorInput  resize ' value={porque4} onChange={(e) => setPorque4(e.target.value)} ></textarea>
                </div>
                <div class="mt-2">
                  <h6>5° Porquê</h6>
                  <textarea disabled={bloqueado || block} cols={7} rows={3} className='form-control  borda colorInput  resize ' value={porque5} onChange={(e) => setPorque5(e.target.value)} ></textarea>
                </div>
              </div>
            </div>
          </body>
          : null}
          <hr />
          <body class="container text-center p-3 ">
            <h6>Descrição da causa raiz identificada </h6>
            <textarea disabled={bloqueado || block} cols={77} rows={2} className='form-control  borda colorInput  resize ' value={descCausaIdentificada} onChange={(e) => setDescCausaIdentificada(e.target.value)}></textarea>

            {/* <input className='mt-3' type="file" onChange={handleImagemChange3} /> */}

            <div className='row mt-3'>
              <div className='col-4'></div>
              {/*  <h6 className='col-1'> Anexar</h6> */}
              <input disabled={bloqueado || block} className='col' type="file" onChange={handleImagemChange3} />
            </div>

            {/* Exibição da prévia da imagem */}
            {imagemPreview3 && (
              <div>
                <img src={imagemPreview3} alt="Prévia da imagem" style={{ maxWidth: '100px' }} />
              </div>
            )}

            {/* Botão de download */}
            {imagem3 && (
              <div>
                <button class="btn btn-outline-success mb-3" onClick={handleDownloadClick3}>Download</button>
              </div>
            )}
          </body>
          <hr />
          <div className=' text-center p-2'>
            <h6 style={{ color: '#000' }} >Análise de risco e oportunidades</h6>
          </div>
          <body class="container text-center align-items-center justify-content-center p-1 ">
            <div class="col  align-items-center justify-content-center  ">

              <div class="col-auto mt-2 p-1 ">
                <h6>Existe necessidade de alteração de risco e oportunidades?</h6>
              </div>
              <div class="col-2 offset-5 p-1">
                <select disabled={bloqueado || block} className=' form-select  borda align-items-center text-center  colorInput me-2 ' value={analiseDeRisco} onChange={(e) => setAnaliseDeRisco(e.target.value)}>
                  <option selected value="...">Selecione...</option>
                  <option value="sim">Sim</option>
                  <option value="nao">Não</option>
                </select>
              </div>
              <div class="col-auto p-1">
                {analiseDeRisco === 'sim' ? <h6>Descreva</h6> : null}

              </div>
              <div class="col-auto  mt-1">
                {analiseDeRisco === 'sim' ?
                  <textarea disabled={bloqueado} cols={7} rows={3} className='form-control  borda colorInput  resize ' value={descAnaliseDeRisco} onChange={(e) => setDescAnaliseDeRisco(e.target.value)}></textarea>
                  : null}


                {/*  <input className='mt-3' type="file" onChange={handleImagemChange4} /> */}

                <div className='row mt-3'>
                  <div className='col-4'></div>
                  {/* <h6 className='col-1'> Anexar</h6> */}
                  <input disabled={bloqueado || block} className='col' type="file" onChange={handleImagemChange4} />
                </div>

                {/* Exibição da prévia da imagem */}
                {imagemPreview4 && (
                  <div>
                    <img src={imagemPreview4} alt="Prévia da imagem" style={{ maxWidth: '100px' }} />
                  </div>
                )}

                {/* Botão de download */}
                {imagem4 && (
                  <div>
                    <button class="btn btn-outline-success mb-3" onClick={handleDownloadClick4}>Download</button>
                  </div>
                )}
              </div>
            </div>
          </body>
          <hr />
          <div className=' text-center p-2'>
            <h5 style={{ color: '#000' }}>Ação Corretiva</h5>
          </div>
          <body class="container text-center  ">
            <div class="col  align-items-center justify-content-center  ">
              <div class="row d-flex align-items-start justify-content-center p-2 ">
                <div class="col-2 -p-4 ">
                  <select disabled={bloqueado || block} className=' form-select  borda align-items-center text-center colorInput me-2 ' value={acaoCorretiva} onChange={(e) => setAcaoCorretiva(e.target.value)} >
                    <option selected value="...">Selecione...</option>
                    <option value="sim">Sim</option>
                    <option value="nao">Não</option>
                  </select>
                </div>
                {acaoCorretiva === 'nao' ?
                  <h6 class=" mt-3">Justificativa</h6>
                  : null}

                {acaoCorretiva === 'nao' ?
                  <textarea disabled={bloqueado || block} cols={8} rows={3} className='form-control  borda colorInput  resize mt-3 ' value={justAcaoCorretiva} onChange={(e) => setJustAcaoCorretiva(e.target.value)}></textarea>
                  : null}


              </div>
            </div>
          </body>

          <body class="container text-center  ">
            <div class="col  align-items-center justify-content-center  ">
              <div class="row d-flex align-items-start justify-content-center p-2 ">

                <div class="col-2 mt-2 ">
                  <h6>Aplicável a outros setores?</h6>
                  <select disabled={bloqueado || block} className=' form-select  borda align-items-center text-center colorInput me-2 mt-3' value={aplicAvelSetores} onChange={(e) => setAplicAvelSetores(e.target.value)}>
                    <option selected value="...">Selecione...</option>
                    <option value="sim">Sim</option>
                    <option value="nao">Não</option>
                  </select>
                </div>

                {aplicAvelSetores === 'sim' ? <h6 class=" mt-3">Descreva</h6> : null}

                {aplicAvelSetores === 'sim' ? <textarea disabled={bloqueado} cols={8} rows={3} className='form-control  borda colorInput  mt-3 resize ' value={descAplicavelSetores} onChange={(e) => setDescAplicavelSetores(e.target.value)} ></textarea> : null}



                <div className='row mt-3'>
                  <div className='col-4'></div>
                  {/*  <h6 className='col-1'> Anexar</h6> */}
                  <input disabled={bloqueado || block} className='col' type="file" onChange={handleImagemChange5} />
                </div>

                {/* Exibição da prévia da imagem */}
                {imagemPreview5 && (
                  <div>
                    <img src={imagemPreview5} alt="Prévia da imagem" style={{ maxWidth: '100px' }} />
                  </div>
                )}

                {/* Botão de download */}
                {imagem5 && (
                  <div>
                    <button class="btn btn-outline-success mb-3" onClick={handleDownloadClick5}>Download</button>
                  </div>
                )}

              </div>
            </div>
          </body>

          <div className=' text-center mt-5 p-2'>
            <h6 style={{ color: '#000' }}>Plano de ação</h6>
          </div>

          <body class="container text-center mt-3 cinzaclaro ">


            <div class="col  align-items-center justify-content-center p-2 ">

              <div class="row d-flex align-items-center justify-content-center ">
                <div class="col-1">
                  <h6>N° da ação</h6>
                </div>

                <div class="col-4 ">
                  <h6>Descrição da ação</h6>
                </div>

                <div class="col-2">
                  <h6>Responsável pela ação</h6>
                </div>

                <div class="col-2">
                  <h6 >Previsão de implementação</h6>
                </div>

                <div class="col-1">
                  <h6 >Conclusão</h6>
                </div>
                <div class="col-2">

                </div>
              </div>
            </div>
          </body>

          <body class="container text-center colorInput ">
            <div class="col  align-items-center justify-content-start p-2 colorInput">
              {/* {listaDeAcoes} */}

              {acoes.map((f, i) => <div key={i} class="row d-flex align-items-start justify-content-center mt-2 ">

                <div class="col-1">{f.item1} </div>
                <div class="col-4 ">{f.acao1}</div>
                {/* <div class="col-4"> <textarea rows={3} cols={50} readOnly className=" bordaa  text-center colorInput resize">{f.acao1}</textarea></div>  */}
                <div class="col-2">{f.responsavelAcao1}</div>
                <div class="col-2">{f.acao1 && f.previsaoAcao1 !== '' && (moment(f.previsaoAcao1).format('DD/MM/YYYY'))} </div>
                <div class="col-1">{f.acao1 && f.execucaoAcao1 !== '' && (moment(f.execucaoAcao1).format('DD/MM/YYYY'))}</div>
                {f.acao1 && isDataLoaded === true ? (<div class="col-2">  <button disabled={bloqueado || block} onClick={() => ClickDelete(f.id)} className="far fa-trash-alt icone-acao red botaao"></button></div>) : <div class="col-2"></div>}

              </div>)}

            </div>
          </body>

          <br />

          {isDataLoaded === true ? (

            <div class="row d-flex align-items-end justify-content-end p-1 ">

              <div class="col-4">
                <button type="button" class="botaoadicionar" disabled={bloqueado || block} data-bs-toggle="modal" data-bs-target="#ModalAcoes" >adicionar</button>
              </div>
            </div>

          ) : null}



          <div class="modal" id="ModalAcoes" tabindex="" aria-labelledby="ModalAcoesLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="ModalAcoesLabel">Ações</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                  <div class="container text-center  ">
                    <div class="col  align-items-center justify-content-center p-2 ">
                      <div class="row d-flex align-items-center justify-content-center ">
                        <div class="col-2">
                          <h6>N° da ação</h6>
                          {/*  <input placeholder='Item' className='form-control  borda text-center colorInput ' value={ item1 }  onChange={(e) => { setItem1(e.target.value)  }} ></input>  */}
                          <input disabled={bloqueado || block}
                            placeholder="Item"
                            className="form-control  borda text-center colorInput"
                            value={numeroItem}
                            /* readOnly */
                            onChange={(e) => { setItem1(e.target.value) }}
                          ></input>
                        </div>

                        <div class="col-7 ">
                          <h6>Descrição da ação</h6>
                          <textarea disabled={bloqueado || block} cols={8} rows={1} placeholder='Ação' className='form-control  borda text-center colorInput resize ' value={acao1} onChange={(e) => setAcao1(e.target.value)}></textarea>
                        </div>

                        <div class="col-4">
                          <h6>Responsável pela ação</h6>
                          <input disabled={bloqueado || block} list='ListaLogin' cols={8} rows={1} placeholder='Responsável' className='form-control  borda text-center colorInput resize ' value={responsavelAcao1} onChange={(e) => setResponsavelAcao1(e.target.value)}></input>

                          <datalist id="ListaLogin">
                            {listaLogin.map((e) => (<option key={e.id} > {e.usuario} </option>))}
                          </datalist>
                        </div>

                        <div class="col-2">
                          <h6>Previsão de implementação</h6>
                          <input disabled={bloqueado || block} type='date' placeholder='Previsão' className='form-control  borda text-center colorInput ' value={previsaoAcao1} onChange={(e) => setPrevisaoAcao1(e.target.value)}></input>
                        </div>

                        {/*           <div class="col-2">
          <h6>Execução</h6>
            <input disabled={bloqueado} type='date' placeholder='Execução' className='form-control  borda text-center colorInput ' value={execucaoAcao1} onChange={(e) => setExecucaoAcao1 (e.target.value)}></input>      
          </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                  <button type="button" class="btn btn-success" disabled={bloqueado || block} onClick={(e) => {
                    setNumeroItem(numeroItem + 1);
                    AcoesClick(e);
                    LimparAcao();
                  }}>Salvar</button>
                </div>
              </div>
            </div>
          </div>

          <hr />

          {setorDoCargo === 'SGI' ?

            <div className=' text-center p-2'>
              {/*   <p>Acresentar os itens,mesmo da tabela acima/ previsao e execuçao mudar para date visivel somente ao logim sgi </p> */}
              <h6 >Verificação de eficácia</h6>
            </div>
            : null}
          {setorDoCargo === 'SGI' ?
            <body class="container text-center cinzaclaro " >
              <div class="col  align-items-center justify-content-center p-2 ">
                <div class="row d-flex align-items-center justify-content-center ">
                  {/* <div class="col-2 ">
         <h6>Ação</h6> 
      </div>*/}
                  <div class="col-2">
                    <h6 >Prazo </h6>
                  </div>

                  <div class="col-4">
                    <h6>Responsavel pela verificação</h6>
                  </div>

                  <div class="col-2">
                    <h6 >Data de verificação</h6>
                  </div>
                  {/*      <div class="col-2">
        <h6>Resultado</h6>                     
      </div> */}
                  <div class="col-2">
                    <h6>Observação</h6>
                  </div>
                  <div class="col-1">

                  </div>
                </div>
              </div>
            </body>
            : null}

          {setorDoCargo === 'SGI' ?
            <body class="container text-center  " >
              <div class="col  align-items-center justify-content-center p-2 colorInput">
                {/* {listaVerificacao} */}
                {verificaEficacia.map((v) => (
                  <div key={v.id} className="row d-flex align-items-center justify-content-center">
                    {/* <div class="col-2 ">  <textarea className=" bordaa  text-center colorInput resize mt-4">{v.verAcao1}</textarea>   </div>*/}
                    <div class="col-2 text-center">{v.verResponsavelAcao1 && (v.verPrevisaoAcao1)}</div>
                    <div class="col-4"> <textarea className=" bordaa  text-center colorInput resize mt-4">{v.verResponsavelAcao1}</textarea> </div>

                    {/* <div class="col-1"> {moment(v.verExecucaoAcao1).format('DD/MM/YYYY')} </div> */}
                    <div className="col-2 text-center">{v.verResponsavelAcao1 && (moment(v.verExecucaoAcao1).format('DD/MM/YYYY'))}
                    </div>
                    {/* <div class="col-2 text-center"> {v.verResultado1}  </div> */}
                    <div class="col-2 "> <textarea className=" bordaa  text-center colorInput resize mt-4">{v.verComentario1}</textarea> </div>


                    {setorDoCargo === 'SGI' ?
                      <div class="col-1"> {v.verResponsavelAcao1 && isDataLoaded === true ? (<button disabled={bloqueado} onClick={() => ClickDeleteVerifica(v.id)} className="far fa-trash-alt icone-acao red botaao"></button>) : <div class="col-2"></div>}</div>
                      : null}

                    {setorDoCargo !== 'SGI' ?
                      <div class="col-1"> </div>
                      : null}
                  </div>
                ))}
              </div>
            </body>
            : null}

          <br />

          <div class="modal" id="ModalVerificacao" tabindex="" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="exampleModalLabel">Verificação de eficácia</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <body class="container text-center  " >
                    <div class="col  align-items-center justify-content-center p-2 ">
                      <div class="row d-flex align-items-center justify-content-center ">
                        {/*               <div class="col-6 ">
              <h6>Ação</h6> 
              <textarea  cols={8} rows={1}  disabled={ bloqueado} placeholder='Ação'  className='form-control  borda text-center colorInput resize ' value={verAcao1} onChange={(e) => setVerAcao1 (e.target.value)}></textarea >
              </div> */}
                        <div class="col-2">
                          <h6>Prazo</h6>
                          <input disabled={/* isDisabled || */ bloqueado} placeholder='Previsão' className='form-control  borda text-center colorInput ' value={verPrevisaoAcao1} onChange={(e) => setVerPrevisaoAcao1(e.target.value)} ></input>
                        </div>

                        <div class="col-4">
                          <h6>Responsável pela verificação</h6>
                          <textarea cols={8} disabled rows={1} placeholder='Responsável' className='form-control  borda text-center colorInput resize' onChange={(e) => setVerResponsavelAcao1(e.target.value)} value={verResponsavelAcao1}></textarea >
                        </div>

                        <div class="col-3 mt-3">
                          <h6>Data da verificação</h6>
                          <input type='date' disabled={/* isDisabled || */ bloqueado} placeholder='Execução' className='form-control  borda text-center colorInput ' value={verExecucaoAcao1} onChange={(e) => setVerExecucaoAcao1(e.target.value)}></input>
                        </div>
                        {/*         <div class="col-3 mt-3"> 
                 <h6>Resultado</h6> 
                  <input disabled={/ bloqueado} placeholder='Resultado'  className='form-control  borda text-center colorInput ' value={verResultado1} onChange={(e) => setVerResultado1 (e.target.value)}></input>                    
                </div> */}
                        <div class="col-6 mt-3">
                          <h6>Observação</h6>
                          <textarea cols={8} rows={1} disabled={bloqueado} placeholder='Deixe um comentário' className='form-control  borda text-center colorInput resize' value={verComentario1} onChange={(e) => setVerComentario1(e.target.value)}></textarea>
                        </div>
                      </div>
                    </div>
                  </body>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                  <button type="button" class="btn btn-success" disabled={bloqueado} onClick={(e) => VerificaEficaciaClick(e) & LimparVerificacao(e)} >Salvar</button>
                </div>
              </div>
            </div>
          </div>


          {setorDoCargo === 'SGI' & isDataLoaded === true ?
            <div class="row d-flex align-items-end justify-content-end p-1 ">
              <div class="col-4">

                <button type="button" class="botaoadicionar" data-bs-toggle="modal" data-bs-target="#ModalVerificacao" >adicionar </button>
              </div>
            </div>


            : null}


          {setorDoCargo === 'SGI' ?
            <div className=' text-center p-2'>
              <h6 >Conclusão</h6>
            </div>
            : null}

          {setorDoCargo === 'SGI' ?

            <body class="container text-center  ">
              <div class="col  align-items-center justify-content-center  ">
                <div class="row d-flex align-items-center justify-content-center ">
                  <div class="col-1 mt-2 ">
                    <h6>Responsável</h6>
                  </div>
                  <div class="col-4 ">
                    <input /*  disabled={isDisabled2} */ disabled={bloqueado} className='form-control  borda text-center colorInput ' onChange={(e) => setEncerraResponsavel(e.target.value)} value={encerraResponsavel}></input>
                  </div>
                  <div class="col-4 "></div>
                  <div class="col-1 mt-2">
                    <h6>Data</h6>
                  </div>
                  <div class="col-2 ">
                    <input  /* disabled={isDisabled2} */ disabled={bloqueado} className='form-control  borda text-center colorInput ' type='date' name='dataEncerra' id='dataEncerra' onChange={(e) => setEncerraData(e.target.value)} value={encerraData}></input>
                  </div>
                </div>
              </div>
            </body>

            : null}
                     {setorDoCargo === 'SGI' & isDataLoaded === true ?
            <div class="row d-flex align-items-end justify-content-end p-1 ">
              <div class="col-4">

                <button type="button" class="botaoadicionar" data-bs-toggle="modal" data-bs-target="#ModalVerificacao" >adicionar </button>
              </div>
            </div>


            : null}


          {setorDoCargo === 'SGI' ?
            <div className=' text-center p-2'>
              <h6 >Conclusão</h6>
            </div>
            : null}

          {setorDoCargo === 'SGI' ?

            <body class="container text-center  ">
              <div class="col  align-items-center justify-content-center  ">
                <div class="row d-flex align-items-center justify-content-center ">
                  <div class="col-1 mt-2 ">
                    <h6>Responsável</h6>
                  </div>
                  <div class="col-4 ">
                    <input /*  disabled={isDisabled2} */ disabled={bloqueado} className='form-control  borda text-center colorInput ' onChange={(e) => setEncerraResponsavel(e.target.value)} value={encerraResponsavel}></input>
                  </div>
                  <div class="col-4 "></div>
                  <div class="col-1 mt-2">
                    <h6>Data</h6>
                  </div>
                  <div class="col-2 ">
                    <input  /* disabled={isDisabled2} */ disabled={bloqueado} className='form-control  borda text-center colorInput ' type='date' name='dataEncerra' id='dataEncerra' onChange={(e) => setEncerraData(e.target.value)} value={encerraData}></input>
                  </div>
                </div>
              </div>
            </body>

            : null}

          {isDataLoaded === true || setorLogado === responsavel2 || setorDoCargo === 'SGI' ? (
            <div class="row   align-items-middle justify-content-end p-5 ">
              <div class="col-3 me-5 ">
                <Link to="/app/PlanoDeAcoes" className="nav-link logout" aria-current="page" >  <button type="button" class="botaoadicionar" > Plano de Ações </button></Link>
              </div>
            </div>
          ) : null}
       {setorDoCargo === 'SGI' ?
          <div class=" d-flex align-items-end justify-content-end p-1 mt-2 me-1">
            <div class="col-2 me-5">
              <button onClick={() => GerarPDF()} className="btn btn-danger  btn-cli" ><i className="far fa-file-pdf"></i> Gerar PDF </button>
            </div>
          </div>
            : null}
          <br /> <br />

        </ContainerForm>
      </Container>


      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
                    <div className="offcanvas-header">


                        <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
                    </div>
                    <Offcanvas.Body>
                        <ul>
                            <li className={`${liClicked ? 'li-slide-right' : ''}`} >
                                <Link to="/app/SGI" style={{ textDecoration: 'none' }}>
                                    <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
                            </li>

                        </ul>
                    </Offcanvas.Body>
                </Offcanvas>
  </div>  
  </div>
};
export default InvestNC;